
// import $ from 'jquery';
import ahoy from 'ahoy.js';
import { saveVoiceoverDraft, restoreVoiceoverDraft } from './voiceoverDraft';
import LazyLoad from '~/modules/LazyLoad.js';
import CancellationPolicyForm from '~/modules/CancellationPolicyForm.js';
import CheckboxDropdown from '~/modules/CheckboxDropdown.js';
import TrackCategorizationDropdown from '~/modules/TrackCategorizationDropdown.js';
import Dropdown from '~/modules/Dropdown.js';
import ToggleLink from '~/modules/ToggleLink.js';
import PriceInfo from '~/modules/PriceInfo.js';
import ProductFetcher from '~/modules/ProductFetcher.js';
import { buildTrackingPayload, currentUserTrackingContext, shouldTrackGoogleAdsCatalogConversions, shouldTrackVisitorEvents, trackAhoyEvent, trackCatalogEvent, withRankingPayload } from '~/modules/catalogEventTracking.js';
import { bindPersonalProjectUpgradeIntentTracking } from '~/modules/personalProjectAnalytics.js';
import { csrfToken, requestJson, urlEncodedBody } from '~/modules/legacyRequest.js';
import Helpers from './Helpers';
import BulkTrackAudioAnalysis from './BulkTrackAudioAnalysis';
import BulkTrackUploadManager from './BulkTrackUploadManager';
import AlbumBulkArtistSelector from './AlbumBulkArtistSelector';
import shouldClosePopupMenus from './popupMenuClose';
import legacyEventHub from '~/modules/legacyRuntime.js';

const I18n = {};
window.I18n = I18n;

const globalModule = {
  bulkTrackUploadManager: null,

  legacyWindow: function () {
    if (typeof globalThis !== 'undefined') {
      return globalThis;
    }

    if (typeof window !== 'undefined') {
      return window;
    }

    return {};
  },

  legacyJQuery: function () {
    let root = this.legacyWindow();
    return root.jQuery || root.$ || null;
  },

  isFreeTrackingModeEnabled: function () {
    return !!document.querySelector('[data-free-tracking-mode]');
  },

  init: function () {
    // PUBLIC AREA
    this.initI18n();
    this.initAhoy();
    bindPersonalProjectUpgradeIntentTracking();
    this.initMediaBundlePricePreviewForm();
    this.initLazyLoading();
    this.initDropdown();
    this.initCheckboxDropdown();
    this.initTrackCategorizationDropdown();
    this.addScrollToEventListener();
    this.addEventHandlerForGlobalCloseClick();
    this.cleanupServiceWorkers();
    this.addEventListenerForNavSearch();
    this.initToggleLink();
    this.addNavScrollEventListener();
    this.addFlashEventListener();
    this.initSort();
    this.initEventPackPicker();
    this.initEventPackageSearchFilters();
    this.initRadioSubscriptionPricingForm();

    if (document.querySelector('audio')) {
      legacyEventHub.trigger('mountAudioPlayer');
      legacyEventHub.trigger('mountSearchMenu');
      this.initCustomPlaylinks();
      this.addEventHandlerForPlayTracking();
      this.addEventHandlerForFavoriteTracking();
      this.addEventHandlerForSoundEffectFavoriteTracking();
      this.initElementCatapult();
    }


    this.addEventHandlerForConversionTracking();
    this.addEventHandlerForSubscriptionSelection();
    this.addEventHandlerForPhoneMessageConfiguratorForm();
    this.addEventHandlerForOnePlayingAudioTagAtATime();
    this.initReviewAudioWaveforms();
    this.initCustomerPlaylistPreview();
    this.initReviewEnergyTrainingControls();
    this.initPublishReviewConfirmForm();
    this.initVoiceoverConsentForm();

    this.initMultiStepForm();
    this.initHumanVoiceoverWizard();

    // EDITOR AREA
    this.addEventHandlerForCopyButton();
    this.initProductFetcher();

    // // CUSTOMER AREA
    this.initPriceInfo();
    this.initCheckoutProjectQuickLinks();
    this.addEventHandlerForCheckout();
    this.addEventHandlerForRegistrationEmailCheck();
    this.addEventHandlerForPhoneMessageOrderTemplateSelection();
    this.initCancellationPolicyForm();

    // // MUSICIAN AREA
    this.bulkTrackUploadManager = new BulkTrackUploadManager({
      localeGetter: function () { return I18n.locale; }
    });
    this.initDirectFileUpload();
    this.initTrackMainUploadDropzone();
    this.initSingleFileUploadDropzones();
    this.bulkTrackUploadManager.initDropareas();
    this.bulkTrackUploadManager.initSorting();
    this.albumBulkArtistSelector = new AlbumBulkArtistSelector();
    this.albumBulkArtistSelector.init();
    this.addEventHandlerForTrackFormSubmit();
    this.initTrackDirectUploadLeaveGuard();
    this.addEventHandlerForTrackOriginatorSwitch();
    this.addEventHandlerForTrackProStatusDetailsToggle();
    this.addEventHandlerForTrackAiUsageDetailsToggle();
    this.initTrackCategorizationProgress();
    this.initAlbumCategorizationProgress();
    this.initTrackRequiredCheckboxGuard();
    this.addEventHandlerForMusicSourceSelect();
    this.addEventHandlerForVoiceSourceSelect();
    this.initOverlay();
    this.addEventHandlerForCustomTagInput();
    this.initAlbumTrackMappingSearch();
    this.initPendingDemoDownloadOverlay();
  },

  initEventPackPicker: function () {
    let root = document.querySelector('[data-event-pack-picker-root]');
    if (!root) return;

    let toggles = Array.from(document.querySelectorAll('[data-event-pack-picker-toggle]'));
    let countNode = root.querySelector('[data-event-pack-picker-count]');
    let listNode = root.querySelector('[data-event-pack-picker-list]');
    let tracksNode = root.querySelector('[data-event-pack-picker-tracks]');
    let minutesNode = root.querySelector('[data-event-pack-picker-minutes]');
    let clearButton = root.querySelector('[data-event-pack-picker-clear]');
    let continueButton = root.querySelector('[data-event-pack-picker-create-playlist]');
    let basePath = continueButton ? (continueButton.getAttribute('data-event-pack-picker-base-path') || '#') : '#';
    let passthroughQuery = root.getAttribute('data-event-pack-picker-passthrough-query') || '';
    let maxSelections = 3;

    if (!toggles.length || !countNode || !listNode || !continueButton) return;

    function readAttr(node, name) {
      return node.getAttribute(name) || '';
    }

    function escapeHtml(value) {
      return String(value || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    }

    function isSelected(button) {
      return readAttr(button, 'data-event-pack-picker-selected') === 'true';
    }

    function selectedButtons() {
      return toggles.filter(function (toggle) { return isSelected(toggle); });
    }

    function setButtonState(button, selected) {
      let selectedState = selected === true;
      let defaultLabel = readAttr(button, 'data-event-pack-picker-label-default') || ((I18n.locale === 'de') ? 'Für Event vormerken' : 'Save for event');
      let selectedLabel = readAttr(button, 'data-event-pack-picker-label-selected') || ((I18n.locale === 'de') ? 'Für Event vorgemerkt' : 'Saved for event');
      button.setAttribute('data-event-pack-picker-selected', selectedState ? 'true' : 'false');
      button.setAttribute('aria-pressed', selectedState ? 'true' : 'false');
      button.classList.toggle('button--secondary', selectedState);
      button.classList.toggle('button--ghost-secondary', !selectedState);
      button.textContent = selectedState ? selectedLabel : defaultLabel;
      let card = button.closest('.event-pack-search-card');
      if (card) card.classList.toggle('is-selected', selectedState);
    }

    function setActionAvailability(button, enabled, href) {
      if (!button) return;
      if (!enabled) {
        button.classList.add('disabled');
        button.setAttribute('aria-disabled', 'true');
        button.setAttribute('tabindex', '-1');
        button.setAttribute('href', '#');
        return;
      }

      button.classList.remove('disabled');
      button.setAttribute('aria-disabled', 'false');
      button.removeAttribute('tabindex');
      if (href) button.setAttribute('href', href);
    }

    function buildContinueUrl(selectedSourceIds) {
      let params = new URLSearchParams();
      if (passthroughQuery) {
        let passthroughParams = new URLSearchParams(passthroughQuery);
        passthroughParams.forEach(function (value, key) {
          params.append(key, value);
        });
      }
      params.set('selected_sources', selectedSourceIds);
      let query = params.toString();
      return query.length ? (basePath + '?' + query) : basePath;
    }

    function renderSelectionSummary() {
      let selected = selectedButtons().map(function (button) {
        return {
          id: readAttr(button, 'data-event-pack-picker-id'),
          title: readAttr(button, 'data-event-pack-picker-title'),
          trackCount: parseInt(readAttr(button, 'data-event-pack-picker-track-count') || '0', 10) || 0,
          totalMinutes: parseInt(readAttr(button, 'data-event-pack-picker-total-minutes') || '0', 10) || 0
        };
      });

      let totalTracks = 0;
      let totalMinutes = 0;
      selected.forEach(function (item) {
        totalTracks += item.trackCount;
        totalMinutes += item.totalMinutes;
      });

      countNode.textContent = selected.length;
      if (tracksNode) tracksNode.textContent = totalTracks;
      if (minutesNode) minutesNode.textContent = totalMinutes;

      if (!selected.length) {
        listNode.textContent = (I18n.locale === 'de') ? 'Noch keine Pakete vorgemerkt.' : 'No packs selected yet.';
        setActionAvailability(continueButton, false);
        setActionAvailability(clearButton, false);
        return;
      }

      listNode.innerHTML = selected.slice(0, maxSelections).map(function (item) {
        return '<span class="event-pack-search-filters__chip">' + escapeHtml(item.title) + '</span>';
      }).join('');

      setActionAvailability(continueButton, true, buildContinueUrl(selected.map(function (item) { return item.id; }).join(',')));
      setActionAvailability(clearButton, true);
    }

    toggles.forEach(function (button) {
      setButtonState(button, isSelected(button));
      button.addEventListener('click', function (event) {
        event.preventDefault();
        let alreadySelected = isSelected(button);
        if (!alreadySelected && selectedButtons().length >= maxSelections) return;
        setButtonState(button, !alreadySelected);
        renderSelectionSummary();
      });
    });

    if (clearButton) {
      clearButton.addEventListener('click', function (event) {
        event.preventDefault();
        if (clearButton.classList.contains('disabled')) return;
        toggles.forEach(function (button) { setButtonState(button, false); });
        renderSelectionSummary();
      });
    }

    renderSelectionSummary();
  },

  initEventPackageSearchFilters: function () {
    let form = document.querySelector('[data-event-pack-search-filters-form]');
    if (!form) return;

    let fields = Array.prototype.slice.call(form.querySelectorAll('[data-event-pack-search-autosubmit]'));
    if (!fields.length) return;

    let isSubmitting = false;
    fields.forEach(function (field) {
      field.addEventListener('change', function () {
        if (isSubmitting) return;
        isSubmitting = true;

        if (typeof form.requestSubmit === 'function') {
          form.requestSubmit();
        } else {
          form.submit();
        }
      });
    });
  },

  initPublishReviewConfirmForm: function () {
    let form = document.querySelector('[data-action~=publishReviewConfirmForm]');
    if (!form) return;

    let publishReady = String(form.dataset.publishReviewReady || 'false') === 'true';
    let checkbox = form.querySelector('[data-action~=publishReviewConfirmCheckbox]');
    let submit = form.querySelector('[data-action~=publishReviewConfirmSubmit]');
    if (!checkbox || !submit) return;

    function syncState() {
      let enabled = publishReady && checkbox.checked === true;
      submit.disabled = !enabled;
      submit.setAttribute('aria-disabled', enabled ? 'false' : 'true');
      submit.classList.toggle('button--disabled', !enabled);
    }

    checkbox.addEventListener('change', syncState);
    syncState();
  },

  initVoiceoverConsentForm: function () {
    let form = document.querySelector('[data-voiceover-consent-form="true"]');
    if (!form) return;

    let requiredCheckboxes = Array.from(form.querySelectorAll('[data-voiceover-required-consent]'));
    let submit = form.querySelector('[data-voiceover-consent-submit]');
    let hint = form.querySelector('#voiceover-consent-hint');
    if (requiredCheckboxes.length !== 3 || !submit) return;

    function syncState() {
      let enabled = requiredCheckboxes.every(function (checkbox) { return checkbox.checked === true; });
      submit.disabled = !enabled;
      submit.setAttribute('aria-disabled', enabled ? 'false' : 'true');
      submit.classList.toggle('button--disabled', !enabled);
      if (hint) hint.textContent = enabled ? hint.dataset.completeText : hint.dataset.incompleteText;
    }

    requiredCheckboxes.forEach(function (checkbox) { checkbox.addEventListener('change', syncState); });
    syncState();
  },

  initTrackRequiredCheckboxGuard: function () {
    let requiredCheckboxes = Array.from(document.querySelectorAll('[data-action~="trackRequiredCheckbox"]'));
    if (requiredCheckboxes.length === 0) return;

    let form = requiredCheckboxes[0].closest('form');
    if (!form) return;

    let submitButtons = Array.from(form.querySelectorAll('.form-actions [type="submit"], .form-actions input[type="submit"], .form-actions button[type="submit"]'));
    if (submitButtons.length === 0) return;

    function syncState() {
      let allChecked = requiredCheckboxes.every(function (checkbox) { return checkbox.checked; });
      submitButtons.forEach(function (button) {
        button.disabled = !allChecked;
        button.setAttribute('aria-disabled', allChecked ? 'false' : 'true');
        button.classList.toggle('button--disabled', !allChecked);
      });
    }

    requiredCheckboxes.forEach(function (checkbox) {
      checkbox.addEventListener('change', syncState);
    });

    syncState();
  },

  initI18n: function () {
    I18n.locale = document.body?.dataset?.lang || document.documentElement?.lang || 'de';
  },

  initProductFetcher: function() {
    let button = document.querySelector('[data-action~="fetchProductData"]');

    if (button) {
        new ProductFetcher(button, {});
    }
  },


  initMediaBundlePricePreviewForm: function() {
    let selectElements = document.querySelectorAll('.media-bundle-price-preview__select');
    let netPriceElements = document.querySelectorAll('.media-bundle-price-preview__target-net-price');
    let netPriceWithoutDiscountElements = document.querySelectorAll('.media-bundle-price-preview__target-net-price-without-discount');
  
    if (selectElements.length > 0) {
      selectElements.forEach(function(selectElement, index) {
        selectElement.addEventListener('change', function(e) {
          let selectedOption = selectElement.options[selectElement.selectedIndex];
          let netPrice = selectedOption.getAttribute('data-net-price');
          let netPriceWithoutDiscount = selectedOption.getAttribute('data-net-price-without-discount');
  
          // Update the corresponding net price elements
          let netPriceElement = netPriceElements[index];
          let netPriceWithoutDiscountElement = netPriceWithoutDiscountElements[index];
          netPriceElement.textContent = netPrice;
          netPriceWithoutDiscountElement.textContent = netPriceWithoutDiscount;
        });
      });
    }
  },

  addEventHandlerForPhoneMessageConfiguratorForm: function () {
    let form = document.querySelector('[data-action~=phoneMessageConfiguratorForm]');

    if (form) {
      form.addEventListener('change', function () {
        let options = form.querySelectorAll('input[type=radio]:checked');
        let speakerLabel = document.querySelector('[data-action~=phoneMessageConfiguratorFormSpeakerLabel]');
        let trackLabel = document.querySelector('[data-action~=phoneMessageConfiguratorFormTrackLabel]');
        let i = 0;
        let speakerSelected = true;
        let optionsValid = false;

        for (i = 0; i < options.length; i++) {
          if (options[i].dataset.selection === 'music' || options[i].name === 'track_id' || options[i].name === 'phone_message_order[track_id]') {
            trackLabel.textContent = options[i].dataset.label;
          }
          if (options[i].dataset.selection === 'speaker' || options[i].name === 'speaker_id' || options[i].name === 'phone_message_order[speaker_id]') {
            speakerLabel.textContent = options[i].dataset.label;
          }

          if (options[i].id === 'speaker_id_0') {
            speakerSelected = false;
          }

          optionsValid = speakerSelected;
        }

        let submit = form.querySelector('input[type=submit], button[type=submit]');
        if (!submit) return;

        if (optionsValid) {
          submit.removeAttribute('disabled');
        } else {
          submit.setAttribute('disabled', 'disabled');
        }
      });
    }
  },

  addEventHandlerForCopyButton: function() {
    let copyButtons = document.querySelectorAll('[data-action~=initCopyButton]');

    if (copyButtons) {
      for (let i = 0; i < copyButtons.length; i++) {
        let copyContainer = document.querySelector(copyButtons[i].dataset.copyContainerSelector);

        if (copyContainer) {
          copyButtons[i].addEventListener('click', function(e) {
            e.preventDefault();

            navigator.clipboard.writeText(copyContainer.textContent);
          })
        }
      }
    }
  },

  addEventHandlerForOnePlayingAudioTagAtATime: function () {
    function onlyPlayOneIn(container) {
      container.addEventListener("play", function (event) {
        let audio_elements = container.getElementsByTagName("audio");
        let i = 0;

        for (i = 0; i < audio_elements.length; i++) {
          let audio_element = audio_elements[i];
          if (audio_element !== event.target) {
            audio_element.pause();
          }
        }
      }, true);
    }

    function connectCustomPlayButtons(container) {
      let playButtons = container.querySelectorAll('[data-action~=phoneMessageConfiguratorPlayButton]');
      let audioElements = container.getElementsByTagName("audio");

      function formatAudioTime(seconds) {
        if (!Number.isFinite(seconds)) return '--:--';

        let totalSeconds = Math.floor(seconds);
        let minutes = Math.floor(totalSeconds / 60);
        let remainingSeconds = String(totalSeconds % 60).padStart(2, '0');
        return minutes + ':' + remainingSeconds;
      }

      function updateAudioProgress(audioElement, speakerCard) {
        let progress = speakerCard && speakerCard.querySelector('[data-audio-progress]');
        let progressRow = speakerCard && speakerCard.querySelector('[data-audio-progress-row]');
        let time = speakerCard && speakerCard.querySelector('[data-audio-time]');
        let duration = audioElement.duration;
        let currentTime = Math.min(duration, Math.max(0, audioElement.currentTime || 0));

        if (!Number.isFinite(duration) || duration <= 0) {
          if (progressRow) progressRow.style.visibility = 'hidden';
          return;
        }

        if (progressRow) progressRow.style.visibility = 'visible';

        if (progress) {
          let percent = Math.min(100, Math.max(0, (currentTime / duration) * 100));
          progress.value = percent;
          progress.setAttribute('aria-valuenow', String(Math.round(percent)));
          let valueLabel = progress.dataset.audioValueLabel || '%{current} of %{duration}';
          progress.setAttribute('aria-valuetext', valueLabel.replace('%{current}', formatAudioTime(currentTime)).replace('%{duration}', formatAudioTime(duration)));
        }

        if (time) time.textContent = formatAudioTime(currentTime) + ' / ' + formatAudioTime(duration);
      }

      function setAudioStatus(speakerCard, state) {
        let status = speakerCard && speakerCard.querySelector('[data-audio-status]');
        if (!status) return;

        let message = status.dataset['status' + state.charAt(0).toUpperCase() + state.slice(1)];
        if (!message) return;

        status.textContent = message;
        status.removeAttribute('aria-hidden');
        status.style.visibility = 'visible';
      }

      function syncPlayButton(audioElement, playButton, speakerCard, statusState) {
        let isPlaying = !audioElement.paused && !audioElement.ended;
        let isLoading = statusState === 'loading';
        let isActive = isPlaying || isLoading;
        playButton.querySelector('.phone-message-config-radio__play').style = isActive ? 'display: none;' : 'display: inline;';
        playButton.querySelector('.phone-message-config-radio__pause').style = isActive ? 'display: inline;' : 'display: none;';
        if (playButton.hasAttribute('aria-pressed')) playButton.setAttribute('aria-pressed', String(isActive));
        playButton.setAttribute('aria-busy', String(isLoading));

        let label = isLoading ? playButton.dataset.audioLoadingLabel : (isPlaying ? playButton.dataset.audioPauseLabel : playButton.dataset.audioPlayLabel);
        if (label) playButton.setAttribute('aria-label', label);
        updateAudioProgress(audioElement, speakerCard);
        if (statusState) setAudioStatus(speakerCard, statusState);
      }

      playButtons.forEach(function (playButton) {
        let speakerCard = playButton.closest('.human-voiceover-speaker-card');
        let audioElement = speakerCard ? speakerCard.querySelector('audio') : playButton.parentNode.parentNode.parentNode.getElementsByTagName("audio")[0];
        if (!audioElement) return;

        let hasPlayed = false;
        syncPlayButton(audioElement, playButton, speakerCard);
        audioElement.addEventListener('play', function () { syncPlayButton(audioElement, playButton, speakerCard, 'loading'); });
        audioElement.addEventListener('playing', function () {
          hasPlayed = true;
          syncPlayButton(audioElement, playButton, speakerCard, 'playing');
        });
        audioElement.addEventListener('waiting', function () { syncPlayButton(audioElement, playButton, speakerCard, hasPlayed ? 'buffering' : 'loading'); });
        audioElement.addEventListener('pause', function () { syncPlayButton(audioElement, playButton, speakerCard, 'paused'); });
        audioElement.addEventListener('ended', function () {
          hasPlayed = false;
          syncPlayButton(audioElement, playButton, speakerCard, 'ended');
        });
        audioElement.addEventListener('error', function () { syncPlayButton(audioElement, playButton, speakerCard, 'error'); });
        audioElement.addEventListener('timeupdate', function () { updateAudioProgress(audioElement, speakerCard); });
        audioElement.addEventListener('loadedmetadata', function () { updateAudioProgress(audioElement, speakerCard); });
        audioElement.addEventListener('durationchange', function () { updateAudioProgress(audioElement, speakerCard); });

        function toggleAudio(event) {
          if (event.type === 'keydown' && event.key !== 'Enter' && event.key !== ' ') return;
          event.preventDefault();

          if (audioElement.paused || audioElement.ended) {
            if (playButton.getAttribute('aria-busy') === 'true') return;

            for (let i = 0; i < audioElements.length; i++) {
              audioElements[i].pause();
            }

            if (audioElement.ended) audioElement.currentTime = 0;
            if (audioElement.dataset.volume) {
              audioElement.volume = parseFloat(audioElement.dataset.volume);
            }

            syncPlayButton(audioElement, playButton, speakerCard, 'loading');
            let playback = audioElement.play();
            if (playback && typeof playback.catch === 'function') playback.catch(function () { syncPlayButton(audioElement, playButton, speakerCard, 'error'); });
          } else {
            audioElement.pause();
          }
        }

        playButton.addEventListener('click', toggleAudio);
        if (playButton.tagName !== 'BUTTON') playButton.addEventListener('keydown', toggleAudio);
      })
    }

    let containers = document.querySelectorAll('[data-action~=audioPlayGroup]');

    containers.forEach(function (element) {
      onlyPlayOneIn(element);
      connectCustomPlayButtons(element);
    });


    // let phoneMessageConfiguratorPlayButtons = document.querySelector
  },

  initReviewAudioWaveforms: function () {
    let root = document.querySelector('[data-action~=audioPlayGroup], [data-workspace-preview-root]');
    if (!root) return;

    function syncPreviewButton(audio) {
      let cell = audio.closest('.review-preview-cell');
      let button = cell && cell.querySelector('[data-workspace-preview-toggle]');
      let playIcon = cell && cell.querySelector('[data-workspace-preview-icon-play]');
      let pauseIcon = cell && cell.querySelector('[data-workspace-preview-icon-pause]');
      let time = cell && cell.querySelector('[data-workspace-preview-time]');
      if (!button) return;
      if (audio.dataset.previewUnavailable === '1') return;

      button.setAttribute('aria-label', audio.paused ? button.dataset.workspacePreviewLabelPlay : button.dataset.workspacePreviewLabelPause);
      button.removeAttribute('aria-disabled');
      button.classList.remove('is-unavailable');
      button.classList.toggle('is-playing', !audio.paused);
      if (playIcon) playIcon.style.display = audio.paused ? 'inline-flex' : 'none';
      if (pauseIcon) pauseIcon.style.display = audio.paused ? 'none' : 'inline-flex';
      if (time) time.textContent = formatReviewAudioTime(audio.currentTime) + ' / ' + formatReviewAudioTime(audio.duration);
    }

    function showPreviewError(audio) {
      let cell = audio.closest('.review-preview-cell');
      let button = cell && cell.querySelector('[data-workspace-preview-toggle]');
      let time = cell && cell.querySelector('[data-workspace-preview-time]');
      if (button) {
        button.setAttribute('aria-label', button.dataset.workspacePreviewLabelError);
        button.setAttribute('aria-disabled', 'true');
        button.classList.add('is-unavailable');
        audio.dataset.previewUnavailable = '1';
      }
      if (time && button) time.textContent = button.dataset.workspacePreviewErrorMessage;
    }

    function formatReviewAudioTime(seconds) {
      if (!Number.isFinite(seconds) || seconds < 0) return '--:--';

      let total = Math.floor(seconds);
      return Math.floor(total / 60) + ':' + String(total % 60).padStart(2, '0');
    }

    if (root.dataset.workspacePreviewGeneric === 'true' && root.dataset.workspacePreviewGenericBound !== '1') {
      root.dataset.workspacePreviewGenericBound = '1';
      root.addEventListener('click', function (event) {
        let button = event.target.closest('[data-workspace-preview-toggle]');
        let cell = button && button.closest('.review-preview-cell');
        let audio = cell && cell.querySelector('audio.review-audio-preview');
        if (!audio || !root.contains(button)) return;

        event.preventDefault();
        event.stopPropagation();
        if (audio.dataset.previewUnavailable === '1') return;
        if (!audio.paused) {
          audio.pause();
          return;
        }

        root.querySelectorAll('audio.review-audio-preview').forEach(function (otherAudio) {
          if (otherAudio !== audio) otherAudio.pause();
        });
        let playPromise = audio.play();
        if (playPromise && playPromise.catch) playPromise.catch(function (error) {
          if (error && error.name === 'AbortError') return;
          showPreviewError(audio);
        });
      });
    }

    function syncPlayed(audio, waveform) {
      let progress = waveform.querySelector('.review-waveform__progress');
      let duration = audio.duration;
      let currentTime = Number(audio.currentTime || 0);
      let durationReady = Number.isFinite(duration) && duration > 0;
      let ratio = durationReady ? (audio.currentTime / duration) * 100 : 0;
      let clamped = Math.max(0, Math.min(100, ratio));

      waveform.setAttribute('aria-valuenow', String(Math.round(clamped)));
      waveform.setAttribute('aria-valuetext', durationReady ? formatReviewAudioTime(audio.currentTime) + ' / ' + formatReviewAudioTime(duration) : formatReviewAudioTime(currentTime) + ', ' + waveform.dataset.waveformDurationUnavailable);
      if (progress && durationReady) progress.style.width = clamped + '%';
    }

    function seek(audio, waveform, ratio) {
      let clamped = Math.max(0, Math.min(1, ratio));
      if (!audio.duration || !isFinite(audio.duration)) {
        audio.dataset.pendingSeekRatio = String(clamped);
        delete audio.dataset.pendingSeekSeconds;
        audio.preload = 'metadata';
        audio.load();
        syncPlayed(audio, waveform);
        return;
      }

      delete audio.dataset.pendingSeekSeconds;
      audio.currentTime = clamped * audio.duration;
      syncPlayed(audio, waveform);
    }

    function seekToSeconds(audio, waveform, seconds) {
      let target = Math.max(0, seconds);
      if (!audio.duration || !isFinite(audio.duration)) {
        audio.dataset.pendingSeekSeconds = String(target);
        delete audio.dataset.pendingSeekRatio;
        audio.preload = 'metadata';
        audio.load();
        syncPlayed(audio, waveform);
        return;
      }

      seek(audio, waveform, target / audio.duration);
    }

    root.querySelectorAll('audio.review-audio-preview[data-waveform-target]').forEach(function (audio) {
      if (audio.dataset.reviewWaveformBound === '1') return;
      audio.dataset.reviewWaveformBound = '1';

      let waveform = root.querySelector('[data-waveform-id="' + audio.dataset.waveformTarget + '"]');
      if (!waveform) return;

      audio.addEventListener('loadedmetadata', function () {
        if (audio.dataset.pendingSeekRatio) {
          seek(audio, waveform, parseFloat(audio.dataset.pendingSeekRatio));
          delete audio.dataset.pendingSeekRatio;
        } else if (audio.dataset.pendingSeekSeconds) {
          seekToSeconds(audio, waveform, parseFloat(audio.dataset.pendingSeekSeconds));
          delete audio.dataset.pendingSeekSeconds;
        }
        syncPlayed(audio, waveform);
        syncPreviewButton(audio);
      });
      audio.addEventListener('timeupdate', function () { syncPlayed(audio, waveform); syncPreviewButton(audio); });
      audio.addEventListener('seeked', function () { syncPlayed(audio, waveform); syncPreviewButton(audio); });
      if (waveform.dataset.reviewWaveformKeyboardBound !== '1') {
        waveform.dataset.reviewWaveformKeyboardBound = '1';
        waveform.addEventListener('keydown', function (event) {
          let currentTime = Number(audio.dataset.pendingSeekSeconds || audio.currentTime || 0);
          let step = event.shiftKey ? 15 : 5;
          let handled = true;

          if (event.key === 'ArrowLeft' || event.key === 'ArrowDown') {
            seekToSeconds(audio, waveform, currentTime - step);
          } else if (event.key === 'ArrowRight' || event.key === 'ArrowUp') {
            seekToSeconds(audio, waveform, currentTime + step);
          } else if (event.key === 'PageDown') {
            seekToSeconds(audio, waveform, currentTime - 15);
          } else if (event.key === 'PageUp') {
            seekToSeconds(audio, waveform, currentTime + 15);
          } else if (event.key === 'Home') {
            seekToSeconds(audio, waveform, 0);
          } else if (event.key === 'End') {
            if (audio.duration && isFinite(audio.duration)) {
              seekToSeconds(audio, waveform, audio.duration);
            } else {
              seek(audio, waveform, 1);
            }
          } else {
            handled = false;
          }

          if (handled) {
            event.preventDefault();
            event.stopPropagation();
          }
        });
      }
      audio.addEventListener('play', function () { waveform.classList.add('is-playing'); syncPreviewButton(audio); });
      audio.addEventListener('pause', function () { waveform.classList.remove('is-playing'); syncPreviewButton(audio); });
      audio.addEventListener('ended', function () { waveform.classList.remove('is-playing'); syncPreviewButton(audio); });
      audio.addEventListener('error', function () { showPreviewError(audio); });
      syncPreviewButton(audio);
    });

    if (root.dataset.reviewWaveformDelegatedBound !== '1') {
      root.dataset.reviewWaveformDelegatedBound = '1';
      root.addEventListener('click', function (event) {
        let waveform = event.target.closest('.review-waveform');
        if (!waveform) return;

        event.preventDefault();
        event.stopPropagation();

        let cell = waveform.closest('.review-preview-cell');
        let audio = cell && cell.querySelector('audio.review-audio-preview');
        if (!audio) return;

        let rect = waveform.getBoundingClientRect();
        if (!rect.width) return;
        seek(audio, waveform, (event.clientX - rect.left) / rect.width);
      }, true);
    }
  },

  initCustomerPlaylistPreview: function () {
    let root = document.querySelector('[data-customer-playlist-preview-root]');
    if (!root || root.dataset.customerPlaylistPreviewBound === '1') return;

    let button = root.querySelector('[data-customer-playlist-preview-toggle]');
    let audios = Array.from(root.querySelectorAll('[data-customer-playlist-preview-track] audio.review-audio-preview'));
    if (!button || audios.length === 0) return;

    root.dataset.customerPlaylistPreviewBound = '1';

    let label = button.querySelector('[data-customer-playlist-preview-label]');
    let playIcon = button.querySelector('[data-customer-playlist-preview-play-icon]');
    let pauseIcon = button.querySelector('[data-customer-playlist-preview-pause-icon]');
    let status = root.querySelector('[data-customer-playlist-preview-status]');
    let trackRows = audios.map(function (audio) { return audio.closest('[data-customer-playlist-preview-track]'); });
    let currentIndex = -1;
    let playingSequence = false;

    function syncButton(playing) {
      button.setAttribute('aria-pressed', String(playing));
      button.setAttribute('aria-label', button.dataset['customerPlaylistPreviewLabel' + (playing ? 'Pause' : 'Play')]);
      if (label) label.textContent = button.dataset['customerPlaylistPreviewText' + (playing ? 'Pause' : 'Play')];
      if (playIcon) playIcon.hidden = playing;
      if (pauseIcon) pauseIcon.hidden = !playing;
      button.classList.toggle('is-playing', playing);
    }

    function syncCurrentTrack(index, state) {
      trackRows.forEach(function (row, rowIndex) {
        if (!row) return;
        let current = rowIndex === index && state;
        row.classList.toggle('instore-radio-playlist-management__track-row--now-playing', current && state === 'playing');
        row.classList.toggle('instore-radio-playlist-management__track-row--paused', current && state === 'paused');
        if (current) row.setAttribute('aria-current', 'true');
        else row.removeAttribute('aria-current');
      });

      if (!status) return;
      if (index < 0 || !state) {
        status.hidden = true;
        status.textContent = '';
        return;
      }

      let template = status.dataset['customerPlaylistPreviewStatus' + (state === 'playing' ? 'Playing' : 'Paused')];
      if (!template) {
        status.hidden = true;
        status.textContent = '';
        return;
      }
      let title = trackRows[index].querySelector('.instore-radio-playlist-management__track-info strong')?.textContent.trim() || '';
      status.textContent = template.replace('%{title}', title).replace('%{index}', String(index + 1)).replace('%{count}', String(audios.length));
      status.hidden = false;
    }

    function playFrom(index) {
      while (index < audios.length && audios[index].dataset.previewUnavailable === '1') index += 1;
      if (!playingSequence || index >= audios.length) {
        playingSequence = false;
        currentIndex = -1;
        syncButton(false);
        syncCurrentTrack(-1, null);
        return;
      }

      currentIndex = index;
      let audio = audios[index];
      syncCurrentTrack(index, 'playing');

      try {
        if (audio.ended) audio.currentTime = 0;
        let playPromise = audio.play();
        if (playPromise && playPromise.catch) {
          playPromise.catch(function (error) {
            if (error && error.name === 'AbortError') return;
            if (playingSequence && currentIndex === index) playFrom(index + 1);
          });
        }
      } catch (error) {
        playFrom(index + 1);
      }
    }

    audios.forEach(function (audio, index) {
      audio.addEventListener('ended', function () {
        if (playingSequence && currentIndex === index) playFrom(index + 1);
      });
      audio.addEventListener('error', function () {
        if (playingSequence && currentIndex === index) playFrom(index + 1);
      });
    });

    button.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();

      if (playingSequence) {
        let currentAudio = audios[currentIndex];
        playingSequence = false;
        syncButton(false);
        syncCurrentTrack(currentIndex, 'paused');
        if (currentAudio) currentAudio.pause();
        return;
      }

      playingSequence = true;
      syncButton(true);
      playFrom(currentIndex >= 0 ? currentIndex : 0);
    });

    root.addEventListener('click', function (event) {
      let previewButton = event.target.closest('[data-workspace-preview-toggle]');
      if (!previewButton || !root.contains(previewButton)) return;

      playingSequence = false;
      currentIndex = -1;
      syncButton(false);
      syncCurrentTrack(-1, null);
    });

    syncButton(false);
  },

  initReviewEnergyTrainingControls: function () {
    let root = document.querySelector('[data-action~=audioPlayGroup]');
    if (!root || root.dataset.reviewEnergyControlsBound === '1') return;
    root.dataset.reviewEnergyControlsBound = '1';

    function updateSliderRow(slider) {
      let container = slider.closest('.col8');
      if (!container) return;
      let valueNode = container.querySelector('.js-review-energy-value');
      if (valueNode) valueNode.textContent = slider.value;
      let applyCheckbox = container.querySelector('input[data-review-energy-apply="true"]');
      if (applyCheckbox) applyCheckbox.checked = true;
    }

    root.querySelectorAll('.js-review-energy-slider').forEach(function (slider) {
      let container = slider.closest('.col8');
      if (!container) return;
      let valueNode = container.querySelector('.js-review-energy-value');
      if (valueNode) valueNode.textContent = slider.value;
    });

    root.addEventListener('input', function (event) {
      let slider = event.target.closest('.js-review-energy-slider');
      if (!slider) return;
      updateSliderRow(slider);
    }, true);

    root.addEventListener('change', function (event) {
      let slider = event.target.closest('.js-review-energy-slider');
      if (!slider) return;
      updateSliderRow(slider);
    }, true);
  },

  initAhoy: function () {
    ahoy.configure({
      cookies: false,
      visitsUrl: '/ahoy/visits',
      eventsUrl: '/ahoy/events'
    });
    ahoy.debug();
  },

  addNavScrollEventListener: function () {
    let navElement = document.querySelector('[data-action~="nav-transparent-present"]');
    let visibleState = false;

    if (navElement) {
      if (window.scrollY > 50) {
        navElement.classList.remove('nav--transparent');
      }

      document.addEventListener('scroll', function () {
        if (window.scrollY > 50 && visibleState === false) {
          navElement.classList.remove('nav--transparent');
          visibleState = true;
        }

        if (window.scrollY <= 50 && visibleState === true) {
          navElement.classList.add('nav--transparent');
          visibleState = false;
        }
      })
    }
  },

  addEventHandlerForConversionTracking: function() {
    legacyEventHub.on('updateCart', function (data) {
      var payload = data && data[0] ? data[0] : data;

      // 🔥 Google Ads: Add to Cart

      if (
        payload?.conversion_tracking?.event === "add_to_cart" &&
        payload?.conversion_tracking?.item_type === "track" &&
        window.ConversionTracking?.googleConversion &&
        window.ConversionTracking?.labels?.track_add_cart_guest_customer_only &&
        shouldTrackGoogleAdsCatalogConversions()
      ) {
          window.ConversionTracking.googleConversion(
              window.ConversionTracking.labels.track_add_cart_guest_customer_only
          );
      }
    });
  },

  addEventHandlerForSubscriptionSelection: function () {
    document.querySelectorAll('[data-action~=chooseSubscription]').forEach(function (element) {
      element.addEventListener('click', function (event) {
        event.preventDefault();
        let radio = element.querySelector('input[type="radio"]');
        let form = element.closest('form');
        if (radio) {
          radio.checked = true;
        }
        if (form) {
          if (typeof form.requestSubmit === 'function') {
            form.requestSubmit();
          } else {
            form.submit();
          }
        }
      });
    });
  },

  initRadioSubscriptionPricingForm: function() {
    document.querySelectorAll('[data-action~=initRadioSubscriptionPricingForm]').forEach(function (element) {
      function submitPricingForm() {
        let form = element.closest('form');
        if (!form) return;

        if (typeof form.requestSubmit === 'function') {
          form.requestSubmit();
        } else {
          form.submit();
        }
      }

      element.addEventListener('change', submitPricingForm);

      element.querySelectorAll('[data-radio-pricing-step]').forEach(function (button) {
        button.addEventListener('click', function () {
          let input = element.querySelector('input[name="locations_count"]');
          if (!input) return;

          let minimum = Number(input.min);
          let maximum = Number(input.max);
          let current = Number.parseInt(input.value, 10);
          let step = Number(button.dataset.radioPricingStep);
          let next = Number.isInteger(current) ? Math.min(maximum, Math.max(minimum, current + step)) : minimum;
          if (input.value === String(next)) return;

          input.value = String(next);
          submitPricingForm();
        });
      });
    });
  },

  addFlashEventListener: function () {
    let flashElement = document.querySelector('[data-action~="initFlash"]');

    if (flashElement) {
      let closeButton = flashElement.querySelector('[data-action-flash~="close"]');

      if (closeButton) {
        closeButton.addEventListener('click', function (e) {
          e.preventDefault();
          flashElement.classList.add('flash--hidden');
        });

        setTimeout(function () {
          flashElement.classList.add('flash--hidden');
        }, 5000)
      }
      // flashElement.classList.add('flash--hidden');
    }
  },

  initToggleLink: function () {
    (function () {
      var linkNodes = document.querySelectorAll('[data-action~="initMenuSearchSwitch"]'),
        i,
        linkNodesLength = linkNodes.length;

      for (i = 0; i < linkNodesLength; i += 1) {
        new ToggleLink(linkNodes[i], {
          targetToggleClass: 'nav__search-form-wrapper--visible',
          afterToggle: function () {
            var form = document.querySelector('#header-menu-search-form-wrapper');
            if (form.classList.contains('nav__search-form-wrapper--visible')) {
              form.querySelector('input').focus();
            }
          }
        });
      }
    }());

    (function () {
      var linkNodes = document.querySelectorAll('[data-action~="initMenuBurgerSwitch"]'),
        i,
        linkNodesLength = linkNodes.length;

      for (i = 0; i < linkNodesLength; i += 1) {
        new ToggleLink(linkNodes[i], {
          targetToggleClass: 'overlay-menu--visible',
          lockBodyScrolling: true
        });
      }
    }());
  },

  cleanupServiceWorkers: function () {
    if (!('serviceWorker' in navigator)) return;

    navigator.serviceWorker.getRegistrations().then((registrations) => {
      registrations.forEach((registration) => {
        registration.unregister();
      });
    });
  },

  initLazyLoading: function () {
    var lazyLoader = new LazyLoad();
    window.Audiocrowd.lazyLoader = lazyLoader;
  },

  initDropdown: function () {
    var dropdownNodes = document.querySelectorAll('[data-action~="initDropdown"]'),
      i,
      dropdownNodesLength = dropdownNodes.length;

    for (i = 0; i < dropdownNodesLength; i += 1) {
      new Dropdown(dropdownNodes[i]);
    }
  },

  initCheckboxDropdown: function () {
    var dropdownNodes = document.querySelectorAll('[data-action~="initCheckboxDropdown"]'),
      i,
      dropdownNodesLength = dropdownNodes.length;

    for (i = 0; i < dropdownNodesLength; i += 1) {
      new CheckboxDropdown(dropdownNodes[i]);
    }

    if (document.body.dataset.checkboxStepInteractingBound === '1') return;
    document.body.dataset.checkboxStepInteractingBound = '1';

    function clearStepInteractingState() {
      document.querySelectorAll('[data-action*="trackStep"], [data-action*="albumStep"]').forEach(function (stepContainer) {
        stepContainer.classList.remove('track-step--interacting');
      });
    }

    legacyEventHub.on('closeAllDropdowns', function () {
      clearStepInteractingState();
    });

    legacyEventHub.on('closePopupMenus', function () {
      clearStepInteractingState();
    });

    document.addEventListener('click', function (event) {
      let switchElement = event.target.closest('.checkbox-dropdown__switch');
      if (!switchElement) return;

      let dropdown = switchElement.closest('.checkbox-dropdown');
      let stepContainer = switchElement.closest('[data-action*="trackStep"], [data-action*="albumStep"]');
      if (!dropdown || !stepContainer) return;

      // CheckboxDropdown toggles visibility in its own click handler.
      setTimeout(function () {
        let isOpen = dropdown.classList.contains('checkbox-dropdown--visible');
        clearStepInteractingState();
        if (isOpen) {
          stepContainer.classList.add('track-step--interacting');
        }
      }, 0);
    });
  },

  initTrackCategorizationDropdown: function () {
    let dropdownNodes = document.querySelectorAll('[data-action~="initTrackCategorizationDropdown"]');
    dropdownNodes.forEach(function (dropdownNode) {
      new TrackCategorizationDropdown(dropdownNode);
    });
  },

  addEventHandlerForTrackOriginatorSwitch: function () {
    let originatorContainer = document.querySelector('[data-action~=initTrackOriginatorSwitch]');
    let inputElement = originatorContainer?.querySelector('input');
    let originatorContentNodes = document.querySelectorAll('[data-originator-content]');

    function syncOriginatorVisibility(checked) {
      originatorContentNodes.forEach(function (node) {
        node.classList.toggle('hide-element', checked);
      });
    }

    if (inputElement) {
      syncOriginatorVisibility(inputElement.checked);
    }

    if (!originatorContainer) return;

    originatorContainer.addEventListener('change', function (event) {
      let target = event.target;
      if (!(target instanceof HTMLInputElement)) return;
      syncOriginatorVisibility(target.checked);
    });
  },

  addEventHandlerForTrackAiUsageDetailsToggle: function () {
    function shouldShowDetails(value) {
      return value === 'ai_assisted' || value === 'ai_substantial';
    }

    function syncForSelect(selectElement) {
      if (!selectElement) return;

      let panel = selectElement.closest('.panel');
      let detailsBlock = panel && panel.querySelector('[data-action~=trackAiUsageDetailsBlock]');
      if (!detailsBlock) return;

      detailsBlock.classList.toggle('hide-element', !shouldShowDetails(selectElement.value));
    }

    document.querySelectorAll('select[name*="[track_ai_statements_attributes]"][name*="[ai_usage]"]').forEach(function (selectElement) {
      syncForSelect(selectElement);
      selectElement.addEventListener('change', function () {
        syncForSelect(selectElement);
      });
    });
  },

  addEventHandlerForTrackProStatusDetailsToggle: function () {
    function shouldShowDetails(status) {
      return status && status !== 'not_registered';
    }

    document.querySelectorAll('[data-action~=trackProStatusStatementPanel]').forEach(function (panel) {
      let details = panel.parentNode.querySelector('[data-action~=trackProStatusDetailsFields]');
      if (!details) return;

      function sync() {
        let checked = panel.querySelector('input[type="radio"][name$="[status]"]:checked');
        let status = checked ? checked.value : null;
        details.classList.toggle('hide-element', !shouldShowDetails(status));
      }

      panel.querySelectorAll('input[type="radio"][name$="[status]"]').forEach(function (radio) {
        radio.addEventListener('change', sync);
      });

      sync();
    });
  },

  initTrackCategorizationProgress: function () {
    let root = document.querySelector('[data-action~=initTrackCategorizationProgress]');
    if (!root) return;

    let progressText = root.querySelector('[data-action~=trackCategorizationProgressText]') || document.querySelector('[data-action~=trackCategorizationProgressText]');
    let progressBlock = root.querySelector('[data-action~=trackCategorizationProgressBlock]') || document.querySelector('[data-action~=trackCategorizationProgressBlock]');
    let conflictHint = root.querySelector('[data-action~=trackCategorizationConflictHint]') || document.querySelector('[data-action~=trackCategorizationConflictHint]');
    let suggestionsContainer = root.querySelector('[data-action~=trackCategorizationSuggestions]') || document.querySelector('[data-action~=trackCategorizationSuggestions]');
    if (!progressText) return;

    let selectors = {
      genres: 'input[name="track[genre_ids][]"]',
      tags: 'input[name="track[tag_ids][]"]',
      moods: 'input[name="track[mood_ids][]"]',
      instore: 'input[name="track[instore_tag_ids][]"]',
      instruments: 'input[name="track[instrument_ids][]"]'
    };

    let recommendation = {
      genres: [1, 2],
      tags: [3, 6],
      moods: [3, 4],
      instruments: [2, 4],
      instore: [0, 3]
    };

    let t = {
      de: {
        progressDone: 'Fertig, mehr Angaben brauchen wir nicht.',
        progressNeedsPrefix: 'TagAssist Empfehlung:',
        progressNeedsMoods: 'weitere Stimmung',
        progressNeedsMoodsPlural: 'weitere Stimmungen',
        progressNeedsTags: 'weiteres Thema',
        progressNeedsTagsPlural: 'weitere Themen',
        progressNeedsInstruments: 'weiteres Instrument',
        progressNeedsInstrumentsPlural: 'weitere Instrumente',
        progressFinalizeInstruments: 'Instrumente abschließen',
        progressNeedsConnector: 'und',
        progressNeedsSuffix: 'auswählen.',
        conflictPrefix: 'Hinweis',
        noConflict: 'Keine ungewöhnlichen Kombinationen erkannt.',
        conflictLoading: 'Prüfe Kombinationen…',
        suggestionTitle: 'Passende Vorschläge',
        suggestionLimitHint: 'Stimmungen: max. 3, Themen: max. 3.',
        suggestionCoverageHint: 'Sie haben die empfohlenen Vorschläge übernommen. Sie verpassen dadurch keine Sichtbarkeit: weitere Feinarbeit übernehmen Analyse und Review.',
        suggestionNoFit: 'Alle Möglichkeiten ansehen',
        suggestionNoFitDone: 'Verstanden. Bitte wählen Sie jetzt manuell passende Kategorien.',
        suggestionNoMoreInstruments: 'Keine weiteren Instrumente',
        suggestionNoMoreInstore: 'Keine weiteren Events/Locations',
        guidedNeedGenreMood: 'Schnell und einfach: 1 Genre und 1 Stimmung wählen. Danach bekommen Sie die restlichen Vorschläge von TagAssist.',
        guidedNeedMood: 'Super. Jetzt bitte 1 Stimmung auswählen.',
        guidedReady: 'TagAssist ist bereit. Wählen Sie gezielt passende Vorschläge.',
        stepToggleLabel: 'Bereich ein-/ausklappen'
      },
      en: {
        progressDone: 'TagAssist: Done, no more details needed.',
        progressNeedsPrefix: 'TagAssist recommendation:',
        progressNeedsMoods: 'more mood',
        progressNeedsMoodsPlural: 'more moods',
        progressNeedsTags: 'more topic',
        progressNeedsTagsPlural: 'more topics',
        progressNeedsInstruments: 'more instrument',
        progressNeedsInstrumentsPlural: 'more instruments',
        progressFinalizeInstruments: 'finalize instruments',
        progressNeedsConnector: 'and',
        progressNeedsSuffix: 'to select.',
        conflictPrefix: 'Hint',
        noConflict: 'No unusual combinations detected.',
        conflictLoading: 'Checking combinations…',
        suggestionTitle: 'Matching suggestions',
        suggestionLimitHint: 'Moods: max. 3, topics: max. 3.',
        suggestionCoverageHint: 'You applied the recommended suggestions. You are not missing visibility: additional fine-tuning is handled by analysis and review.',
        suggestionNoFit: 'View all options',
        suggestionNoFitDone: 'Understood. Please choose matching categories manually.',
        suggestionNoMoreInstruments: 'No more instruments',
        suggestionNoMoreInstore: 'No more events/locations',
        guidedNeedGenreMood: 'For TagAssist, first choose 1 genre and 1 mood.',
        guidedNeedMood: 'Great. Now choose 1 mood.',
        guidedReady: 'TagAssist is ready. Select only fitting suggestions.',
        stepToggleLabel: 'Toggle section'
      }
    };

    let locale = (I18n.locale || 'de').toString().toLowerCase().startsWith('de') ? 'de' : 'en';

    function countChecked(selector) {
      return document.querySelectorAll(selector + ':checked').length;
    }

    function inRange(value, range) {
      return value >= range[0] && value <= range[1];
    }

    let selectorByKind = {
      genre: selectors.genres,
      tag: selectors.tags,
      mood: selectors.moods,
      instore: selectors.instore,
      instrument: selectors.instruments
    };
    let selectorBySuggestionGroup = {
      moods: selectors.moods,
      tags: selectors.tags,
      instore_tags: selectors.instore
    };
    let suggestionGroupTargets = {
      moods: 3,
      tags: 3,
      instore_tags: 3
    };
    let suggestionGroupSelectionLimit = {
      moods: 3,
      tags: 3,
      instore_tags: 3
    };
    function taxonomyConflictsEndpoint() {
      let fromData = root.dataset.taxonomyConflictsPath;
      if (fromData) return fromData;

      let path = window.location.pathname || '';
      if (/\/a\//.test(path)) return '/a/tracks/taxonomy_conflicts';
      if (/\/e\//.test(path)) return '/e/tracks/taxonomy_conflicts';
      return '/m/tracks/taxonomy_conflicts';
    }
    let conflictRequestTimer = null;
    let conflictRequestId = 0;
    let hasUserInteraction = false;
    let skipSuggestionFetchCounter = 0;
    let dismissedSuggestionGroups = {};
    let latestSuggestions = {};
    let previousCounts = {
      genres: countChecked(selectors.genres),
      moods: countChecked(selectors.moods)
    };
    let stepElements = {
      genre: document.querySelector('[data-action~=trackStepGenre]'),
      mood: document.querySelector('[data-action~=trackStepMood]'),
      tags: document.querySelector('[data-action~=trackStepTags]'),
      instruments: document.querySelector('[data-action~=trackStepInstruments]'),
      instore: document.querySelector('[data-action~=trackStepInstore]')
    };
    let suggestionGroupExpandStorageKey = `trackTagAssistExpandedGroups:${window.location.pathname}`;
    let manualSuggestionDoneStorageKey = `trackTagAssistManualDone:${window.location.pathname}`;
    let suggestionGroupExpandedState = {};
    let manualSuggestionDoneState = {};

    function loadSuggestionGroupExpandedState() {
      try {
        suggestionGroupExpandedState = JSON.parse(window.sessionStorage.getItem(suggestionGroupExpandStorageKey) || '{}') || {};
      } catch (error) {
        suggestionGroupExpandedState = {};
      }
      try {
        manualSuggestionDoneState = JSON.parse(window.sessionStorage.getItem(manualSuggestionDoneStorageKey) || '{}') || {};
      } catch (error) {
        manualSuggestionDoneState = {};
      }
    }

    function saveSuggestionGroupExpandedState() {
      try {
        window.sessionStorage.setItem(suggestionGroupExpandStorageKey, JSON.stringify(suggestionGroupExpandedState));
      } catch (error) {
        // ignore storage write errors (private mode etc.)
      }
      try {
        window.sessionStorage.setItem(manualSuggestionDoneStorageKey, JSON.stringify(manualSuggestionDoneState));
      } catch (error) {
        // ignore storage write errors (private mode etc.)
      }
    }

    function isSuggestionGroupDone(groupKey) {
      if (groupKey === 'instruments') {
        return manualSuggestionDoneState.instruments === true;
      }
      if (groupKey === 'instore_tags' && manualSuggestionDoneState.instore_tags === true) {
        return true;
      }
      let target = suggestionGroupTargets[groupKey];
      if (!target) return false;
      let selector = selectorBySuggestionGroup[groupKey];
      if (!selector) return false;
      return checkedIds(selector).length >= target;
    }

    function isSuggestionGroupCollapsed(groupKey) {
      return isSuggestionGroupDone(groupKey) && !suggestionGroupExpandedState[groupKey];
    }

    function setStepState(element, state) {
      if (!element) return;
      element.classList.remove('track-step--current', 'track-step--complete', 'track-step--upcoming', 'form-required-callout', 'form-required-callout--success');
      element.classList.add(`track-step--${state}`);

      if (state === 'current') {
        element.classList.add('form-required-callout');
      } else if (state === 'complete') {
        element.classList.add('form-required-callout', 'form-required-callout--success');
      }
    }

    function syncStepStates(counts) {
      let instrumentsDone = manualSuggestionDoneState.instruments === true;

      if (counts.genres === 0) {
        setStepState(stepElements.genre, 'current');
        setStepState(stepElements.mood, 'upcoming');
        setStepState(stepElements.tags, 'upcoming');
        setStepState(stepElements.instruments, 'upcoming');
        setStepState(stepElements.instore, 'upcoming');
        return;
      }

      if (counts.moods === 0) {
        setStepState(stepElements.genre, 'complete');
        setStepState(stepElements.mood, 'current');
        setStepState(stepElements.tags, 'upcoming');
        setStepState(stepElements.instruments, 'upcoming');
        setStepState(stepElements.instore, 'upcoming');
        return;
      }

      if (counts.moods < 3) {
        setStepState(stepElements.genre, 'complete');
        setStepState(stepElements.mood, 'current');
        setStepState(stepElements.tags, 'upcoming');
        setStepState(stepElements.instruments, 'upcoming');
        setStepState(stepElements.instore, 'upcoming');
        return;
      }

      if (counts.tags < 3) {
        setStepState(stepElements.genre, 'complete');
        setStepState(stepElements.mood, 'complete');
        setStepState(stepElements.tags, 'current');
        setStepState(stepElements.instruments, 'upcoming');
        setStepState(stepElements.instore, 'upcoming');
        return;
      }

      if (!instrumentsDone) {
        setStepState(stepElements.genre, 'complete');
        setStepState(stepElements.mood, 'complete');
        setStepState(stepElements.tags, 'complete');
        setStepState(stepElements.instruments, 'current');
        setStepState(stepElements.instore, 'upcoming');
        return;
      }

      setStepState(stepElements.genre, 'complete');
      setStepState(stepElements.mood, 'complete');
      setStepState(stepElements.tags, 'complete');
      setStepState(stepElements.instruments, 'complete');
      setStepState(stepElements.instore, manualSuggestionDoneState.instore_tags === true || counts.instore > 0 ? 'complete' : 'upcoming');
    }

    function syncHintStates(doneFlags, counts) {
      Object.keys(hintElements).forEach(function (key) {
        let element = hintElements[key];
        if (!element) return;

        let done = !!doneFlags[key];
        if (key === 'instore') {
          done = manualSuggestionDoneState.instore_tags === true || ((counts.instore || 0) > 0 && done);
        }
        element.classList.toggle('text-green', done);
        element.classList.toggle('text-grey', !done);
      });
    }
    function clearConflictHighlights() {
      document.querySelectorAll('.checkbox-dropdown__checkboxes .checkbox.checkbox--conflict').forEach(function (row) {
        row.classList.remove('checkbox--conflict');
      });
    }

    function highlightConflictRows(inputs) {
      inputs.forEach(function (input) {
        let row = input.closest('.checkbox');
        if (row) {
          row.classList.add('checkbox--conflict');
        }
      });
    }

    function checkedIds(selector) {
      return Array.from(document.querySelectorAll(selector + ':checked'))
        .map(function (input) { return parseInt(input.value, 10); })
        .filter(function (value) { return !Number.isNaN(value) && value > 0; });
    }

    function inputForItem(item) {
      let selector = selectorByKind[item.kind];
      if (!selector) return null;

      return document.querySelector(`${selector}[value="${item.id}"]`);
    }

    function selectedRowsForGroup(groupKey) {
      let selector = selectorBySuggestionGroup[groupKey];
      if (!selector) return [];

      let kindByGroup = {
        moods: 'mood',
        tags: 'tag',
        instore_tags: 'instore'
      };
      let kind = kindByGroup[groupKey];
      if (!kind) return [];

      return checkedIds(selector).map(function (id) {
        let input = document.querySelector(`${selector}[value="${id}"]`);
        if (!input) return null;
        let label = input.dataset.taxonomyLabel || input.closest('label')?.textContent || '';
        return { kind: kind, id: id, name: label.trim() };
      }).filter(Boolean);
    }

    function renderSuggestions(suggestions) {
      if (!suggestionsContainer) return;
      latestSuggestions = suggestions || {};

      let groups = [
        { key: 'moods', label: I18n.locale === 'de' ? 'Stimmungen' : 'Moods' },
        { key: 'tags', label: I18n.locale === 'de' ? 'Themen' : 'Topics' },
        { key: 'instore_tags', label: I18n.locale === 'de' ? 'Events/Locations (optional)' : 'Events/locations (optional)' }
      ];

      let hasAny = groups.some(function (group) {
        return !dismissedSuggestionGroups[group.key] && Array.isArray(latestSuggestions[group.key]) && latestSuggestions[group.key].length > 0;
      });

      if (!hasAny) {
        suggestionsContainer.innerHTML = '';
        return;
      }

      let html = `<div class="track-tagassist__panel"><div class="text-like-h5 margin-bottom0">${t[locale].suggestionTitle}</div><div class="text-size-small text-grey margin-top5">${t[locale].suggestionLimitHint}</div>`;
      groups.forEach(function (group) {
        let suggestedRows = dismissedSuggestionGroups[group.key] ? [] : (Array.isArray(latestSuggestions[group.key]) ? latestSuggestions[group.key] : []);
        let selectedRows = selectedRowsForGroup(group.key);
        let seen = {};
        let rows = selectedRows.concat(suggestedRows).filter(function (row) {
          let key = `${row.kind}:${row.id}`;
          if (seen[key]) return false;
          seen[key] = true;
          return true;
        });
        if (rows.length === 0) return;

        let done = isSuggestionGroupDone(group.key);
        if (!done && suggestionGroupExpandedState[group.key]) {
          delete suggestionGroupExpandedState[group.key];
          saveSuggestionGroupExpandedState();
        }
        let collapsed = isSuggestionGroupCollapsed(group.key);
        let doneClass = done ? ' track-tagassist__group--done' : '';
        let collapsedClass = collapsed ? ' track-tagassist__group--collapsed' : '';
        let iconClass = done ? 'fa-check' : (collapsed ? 'fa-chevron-down' : 'fa-chevron-up');
        let disabledAttr = done ? '' : ' disabled aria-disabled="true"';
        let selector = selectorBySuggestionGroup[group.key];
        let selectedCount = selector ? checkedIds(selector).length : 0;
        let targetCount = suggestionGroupTargets[group.key];
        let counterText = targetCount ? `${selectedCount}/${targetCount}` : `${selectedCount}`;
        let counterLabel = `<span class="track-tagassist__group-counter" data-kind-group="${group.key}">(${counterText})</span>`;
        let toggleButton = `<button type="button" class="track-tagassist__group-toggle${done ? ' track-tagassist__group-toggle--done' : ' track-tagassist__group-toggle--disabled'}" title="${t[locale].stepToggleLabel}" aria-label="${t[locale].stepToggleLabel}" data-action="trackCategorizationToggleSuggestionGroup" data-kind-group="${group.key}"${disabledAttr}><i class="fa ${iconClass}" aria-hidden="true"></i></button>`;

        let noMoreInstoreChip = '';
        if (group.key === 'instore_tags' && !done) {
          noMoreInstoreChip = `<button type="button" class="tag tag--large tag--text track-tagassist__chip" data-action="trackCategorizationMarkNoMoreInstore"><i class="fa fa-check" aria-hidden="true"></i> ${t[locale].suggestionNoMoreInstore}</button>`;
        }
        html += `<div class="track-tagassist__group${doneClass}${collapsedClass}" data-kind-group="${group.key}"><div class="track-tagassist__group-head text-size-small"><span class="text-like-h5 margin-bottom0 track-tagassist__group-title">${toggleButton}${group.label} ${counterLabel}</span></div><div class="track-tagassist__group-body"><div class="track-tagassist__chips">`;
        rows.forEach(function (row) {
          html += `<button type="button" class="tag tag--large tag--interactive track-tagassist__chip" data-action="trackCategorizationApplySuggestion" data-kind-group="${group.key}" data-kind="${row.kind}" data-id="${row.id}">${row.name}</button>`;
        });
        html += noMoreInstoreChip;
        html += `</div></div></div>`;

        if (group.key === 'tags') {
          html += instrumentSuggestionsHtml(Array.isArray(latestSuggestions.instruments) ? latestSuggestions.instruments : []);
        }
      });
      html += '<p class="text-size-small text-grey margin-top10 margin-bottom0 hide-element" data-action="trackCategorizationSuggestionCompletion"></p>';
      html += '</div>';
      suggestionsContainer.innerHTML = html;
      updateSuggestionButtonsState();
      updateInstrumentSuggestionButtonsState();
    }

    function renderSuggestionsGuidance(message) {
      if (!suggestionsContainer) return;
      suggestionsContainer.innerHTML = `<div class="track-tagassist__panel"><p class="text-like-h5 margin-bottom0">${message}</p></div>`;
    }

    function renderSuggestionsLoading() {
      if (!suggestionsContainer) return;
      suggestionsContainer.innerHTML = `<div class="track-tagassist__panel"><p class="text-like-h5 margin-bottom0"><i class="fa fa-spinner fa-spin"></i></p></div>`;
    }

    function instrumentSuggestionsHtml(rows) {
      let suggestedRows = Array.isArray(rows) ? rows : [];
      let selectedRows = checkedIds(selectors.instruments).map(function (id) {
        let input = document.querySelector(`${selectors.instruments}[value="${id}"]`);
        if (!input) return null;
        let label = input.dataset.taxonomyLabel || input.closest('label')?.textContent || '';
        return { kind: 'instrument', id: id, name: label.trim() };
      }).filter(Boolean);

      // Keep selected suggestions visible (for quick deselect) and prepend them.
      let seen = {};
      let mergedRows = selectedRows.concat(suggestedRows).filter(function (row) {
        let key = `${row.kind}:${row.id}`;
        if (seen[key]) return false;
        seen[key] = true;
        return true;
      });

      if (mergedRows.length === 0) {
        return '';
      }

      let title = I18n.locale === 'de' ? 'Instrumente' : 'Instruments';
      let openDropdownText = I18n.locale === 'de' ? 'Anderes Instrument auswählen' : 'Choose another instrument';
      let done = manualSuggestionDoneState.instruments === true;
      let collapsed = done && !suggestionGroupExpandedState.instruments;
      let doneClass = done ? ' track-tagassist__group--done' : '';
      let collapsedClass = collapsed ? ' track-tagassist__group--collapsed' : '';
      let selectedCount = checkedIds(selectors.instruments).length;
      let iconClass = done ? 'fa-check' : 'fa-chevron-up';
      let toggleClass = done ? ' track-tagassist__group-toggle--done' : ' track-tagassist__group-toggle--disabled';
      let toggleDisabled = done ? '' : ' disabled aria-disabled="true"';
      let toggleButton = `<button type="button" class="track-tagassist__group-toggle${toggleClass}" title="${t[locale].stepToggleLabel}" aria-label="${t[locale].stepToggleLabel}" data-action="trackCategorizationToggleSuggestionGroup" data-kind-group="instruments"${toggleDisabled}><i class="fa ${iconClass}" aria-hidden="true"></i></button>`;
      let noMoreChip = done ? '' : `<button type="button" class="tag tag--large tag--text track-tagassist__chip" data-action="trackCategorizationMarkNoMoreInstruments"><i class="fa fa-check" aria-hidden="true"></i> ${t[locale].suggestionNoMoreInstruments}</button>`;
      let html = `<div class="track-tagassist__group track-tagassist__group--instruments margin-top10${doneClass}${collapsedClass}" data-kind-group="instruments"><div class="track-tagassist__group-head text-size-small"><span class="text-like-h5 margin-bottom0 track-tagassist__group-title">${toggleButton}${title} <span class="track-tagassist__group-counter" data-kind-group="instruments">(${selectedCount})</span></span></div><div class="track-tagassist__group-body"><div class="track-tagassist__chips margin-top10">`;
      mergedRows.forEach(function (row) {
        html += `<button type="button" class="tag tag--large tag--interactive track-tagassist__chip" data-action="trackInstrumentSuggestionToggle" data-kind="${row.kind}" data-id="${row.id}">${row.name}</button>`;
      });
      html += noMoreChip;
      html += `</div><div class="text-size-small margin-top5"><a href="#" data-action="trackInstrumentSuggestionOpenDropdown">${openDropdownText}</a></div></div></div>`;
      return html;
    }

    function updateInstrumentSuggestionButtonsState() {
      if (!suggestionsContainer) return;
      suggestionsContainer.querySelectorAll('[data-action="trackInstrumentSuggestionToggle"]').forEach(function (button) {
        let item = { kind: button.dataset.kind, id: button.dataset.id };
        let input = inputForItem(item);
        let isChecked = !!(input && input.checked);
        button.classList.toggle('tag--secondary', isChecked);
        button.classList.toggle('tag--opaque', isChecked);
        button.classList.toggle('tag--primary', !isChecked);
      });
    }

    function countAppliedSuggestionsInGroup(groupKey) {
      if (groupKey === 'instruments') {
        return checkedIds(selectors.instruments).length;
      }
      let selector = selectorBySuggestionGroup[groupKey];
      if (!selector) return 0;
      return checkedIds(selector).length;
    }

    function syncSuggestionGroupUI() {
      if (!suggestionsContainer) return;

      suggestionsContainer.querySelectorAll('.track-tagassist__group[data-kind-group]').forEach(function (groupElement) {
        let groupKey = groupElement.dataset.kindGroup;
        if (!groupKey) return;

        let done = isSuggestionGroupDone(groupKey);
        if (!done && suggestionGroupExpandedState[groupKey]) {
          delete suggestionGroupExpandedState[groupKey];
          saveSuggestionGroupExpandedState();
        }
        let collapsed = isSuggestionGroupCollapsed(groupKey);

        groupElement.classList.toggle('track-tagassist__group--done', done);
        groupElement.classList.toggle('track-tagassist__group--collapsed', collapsed);

        let toggleButton = groupElement.querySelector('[data-action="trackCategorizationToggleSuggestionGroup"]');
        if (!toggleButton) return;

        if (done) {
          let iconClass = 'fa-check';
          toggleButton.innerHTML = `<i class="fa ${iconClass}" aria-hidden="true"></i>`;
          toggleButton.classList.add('track-tagassist__group-toggle--done');
          toggleButton.classList.remove('track-tagassist__group-toggle--disabled');
          toggleButton.disabled = false;
          toggleButton.setAttribute('aria-disabled', 'false');
        } else {
          toggleButton.innerHTML = '<i class="fa fa-chevron-up" aria-hidden="true"></i>';
          toggleButton.classList.remove('track-tagassist__group-toggle--done');
          toggleButton.classList.add('track-tagassist__group-toggle--disabled');
          toggleButton.disabled = true;
          toggleButton.setAttribute('aria-disabled', 'true');
        }
      });
    }

    function updateGroupHeaderCounters() {
      if (!suggestionsContainer) return;

      suggestionsContainer.querySelectorAll('.track-tagassist__group-counter[data-kind-group]').forEach(function (counter) {
        let groupKey = counter.dataset.kindGroup;
        if (!groupKey) return;
        let selector = groupKey === 'instruments' ? selectors.instruments : selectorBySuggestionGroup[groupKey];
        if (!selector) return;
        let selectedCount = checkedIds(selector).length;
        if (groupKey === 'instruments') {
          counter.textContent = `(${selectedCount})`;
          return;
        }
        let target = suggestionGroupTargets[groupKey] || 3;
        counter.textContent = `(${selectedCount}/${target})`;
      });
    }

    function updateSuggestionButtonsState() {
      if (!suggestionsContainer) return;
      suggestionsContainer.querySelectorAll('[data-action="trackCategorizationApplySuggestion"]').forEach(function (button) {
        let groupKey = button.dataset.kindGroup;
        let item = { kind: button.dataset.kind, id: button.dataset.id };
        let input = inputForItem(item);
        let isChecked = !!(input && input.checked);
        let groupCount = countAppliedSuggestionsInGroup(groupKey);
        let maxSelection = suggestionGroupSelectionLimit[groupKey] || 2;
        let shouldDisable = !isChecked && groupCount >= maxSelection;

        button.disabled = shouldDisable;
        button.classList.toggle('tag--secondary', isChecked);
        button.classList.toggle('tag--opaque', isChecked);
        button.classList.toggle('tag--primary', !isChecked);
        button.classList.toggle('tag--disabled', shouldDisable);
      });

      function markDropdownCompleted(groupKey, completed) {
        let kindByGroup = {
          moods: 'mood',
          instore_tags: 'instore',
          tags: 'tag'
        };
        let kind = kindByGroup[groupKey];
        if (!kind) return;

        let sampleInput = document.querySelector(`input[data-taxonomy-kind="${kind}"]`);
        if (!sampleInput) return;
        let dropdown = sampleInput.closest('.checkbox-dropdown');
        if (!dropdown) return;
        dropdown.classList.toggle('checkbox-dropdown--completed', completed);
      }

      let completionHint = suggestionsContainer.querySelector('[data-action="trackCategorizationSuggestionCompletion"]');
      if (!completionHint) return;

      let groups = ['moods', 'instore_tags', 'tags'];

      groups.forEach(function (groupKey) {
        let selector = selectorBySuggestionGroup[groupKey];
        let total = suggestionsContainer.querySelectorAll(`[data-action="trackCategorizationApplySuggestion"][data-kind-group="${groupKey}"]`).length;
        if (!selector || total === 0) {
          markDropdownCompleted(groupKey, false);
          return;
        }
        let selectedTotal = checkedIds(selector).length;
        let target = suggestionGroupTargets[groupKey];
        if (target) {
          markDropdownCompleted(groupKey, selectedTotal >= target);
          return;
        }
        markDropdownCompleted(groupKey, selectedTotal > 0);
      });

      let requiredGroups = ['moods', 'tags'];
      let allRecommendedApplied = requiredGroups.every(function (groupKey) {
        return isSuggestionGroupDone(groupKey);
      });

      syncSuggestionGroupUI();
      updateGroupHeaderCounters();

      if (allRecommendedApplied) {
        completionHint.textContent = t[locale].suggestionCoverageHint;
        completionHint.classList.remove('hide-element');
      } else {
        completionHint.textContent = '';
        completionHint.classList.add('hide-element');
      }
    }

    function openDropdownForSelector(selector) {
      if (!selector) return;

      let input = document.querySelector(selector);
      if (!input) return;

      let dropdown = input.closest('.checkbox-dropdown');
      if (!dropdown) return;

      legacyEventHub.trigger('closeAllDropdowns', dropdown);
      dropdown.classList.add('checkbox-dropdown--visible');

      let searchInput = dropdown.querySelector('.checkbox-dropdown__search-input');
      if (searchInput) {
        setTimeout(function () {
          searchInput.focus();
        }, 0);
      }
    }

    function fetchConflictsDebounced() {
      if (!conflictHint) return;

      if (conflictRequestTimer) {
        clearTimeout(conflictRequestTimer);
      }

      conflictHint.textContent = `${t[locale].conflictPrefix}: ${t[locale].conflictLoading}`;
      conflictHint.classList.remove('text-red');

      conflictRequestTimer = setTimeout(function () {
        let requestId = conflictRequestId + 1;
        conflictRequestId = requestId;

        let payload = {
          genre_ids: checkedIds(selectors.genres),
          tag_ids: checkedIds(selectors.tags),
          mood_ids: checkedIds(selectors.moods),
          instore_tag_ids: checkedIds(selectors.instore),
          instrument_ids: checkedIds(selectors.instruments)
        };

        let csrfTokenMeta = document.querySelector('meta[name="csrf-token"]');
        let csrfToken = csrfTokenMeta ? csrfTokenMeta.getAttribute('content') : null;

        fetch(taxonomyConflictsEndpoint(), {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'X-CSRF-Token': csrfToken
          },
          credentials: 'same-origin',
          body: JSON.stringify(payload)
        }).then(function (response) {
          if (!response.ok) throw new Error('conflict_request_failed');
          return response.json();
        }).then(function (data) {
          if (requestId !== conflictRequestId) return;

          clearConflictHighlights();
          dismissedSuggestionGroups = {};
          let conflicts = Array.isArray(data.conflicts) ? data.conflicts : [];

          if (conflicts.length === 0) {
            conflictHint.textContent = t[locale].noConflict;
            conflictHint.classList.remove('text-red');
          } else {
            let conflictInputs = [];
            conflicts.forEach(function (conflict) {
              Array(conflict.items).forEach(function (item) {
                let input = inputForItem(item);
                if (input) conflictInputs.push(input);
              });
            });
            highlightConflictRows(conflictInputs);
            conflictHint.textContent = `${t[locale].conflictPrefix}: ${conflicts.map(function (conflict) { return conflict.message; }).join(' ')}`;
            conflictHint.classList.add('text-red');
          }
          renderSuggestions(data.suggestions || {});
          updateSuggestionButtonsState();
        }).catch(function () {
          if (requestId !== conflictRequestId) return;
          clearConflictHighlights();
          dismissedSuggestionGroups = {};
          conflictHint.textContent = t[locale].noConflict;
          conflictHint.classList.remove('text-red');
          renderSuggestions({});
        });
      }, 220);
    }

    function sync() {
      let counts = {
        genres: countChecked(selectors.genres),
        tags: countChecked(selectors.tags),
        moods: countChecked(selectors.moods),
        instruments: countChecked(selectors.instruments),
        instore: countChecked(selectors.instore)
      };

      if (manualSuggestionDoneState.instruments === true && counts.instruments === 0) {
        manualSuggestionDoneState.instruments = false;
        saveSuggestionGroupExpandedState();
      }
      let doneFlags = {
        genres: inRange(counts.genres, recommendation.genres),
        tags: inRange(counts.tags, recommendation.tags),
        moods: counts.moods >= 3,
        instruments: inRange(counts.instruments, recommendation.instruments),
        instore: inRange(counts.instore, recommendation.instore)
      };

      // Progress should mirror the guided workflow (step completion),
      // while recommendation ranges remain visual guidance only.
      let progressDoneFlags = {
        genres: counts.genres >= 1,
        tags: counts.tags >= 3,
        moods: counts.moods >= 3,
        instruments: manualSuggestionDoneState.instruments === true
      };
      let coreDoneCount = ['genres', 'tags', 'moods', 'instruments'].filter(function (key) { return progressDoneFlags[key]; }).length;
      let allDone = coreDoneCount === 4;
      syncStepStates(counts);

      if (counts.genres > previousCounts.genres && counts.genres === 1) {
        legacyEventHub.trigger('closePopupMenus');
      }
      if (counts.moods > previousCounts.moods && counts.moods === 1) {
        legacyEventHub.trigger('closePopupMenus');
      }
      previousCounts = { genres: counts.genres, moods: counts.moods };

      let guidedReady = counts.genres >= 1 && counts.moods >= 1;
      if (!guidedReady) {
        if (progressBlock) progressBlock.classList.add('hide-element');
        clearConflictHighlights();
        conflictHint.textContent = '';
        conflictHint.classList.remove('text-red');
        if (counts.genres >= 1 && counts.moods === 0) {
          renderSuggestionsGuidance(t[locale].guidedNeedMood);
        } else {
          renderSuggestionsGuidance(t[locale].guidedNeedGenreMood);
        }
        return;
      }

      if (progressBlock) progressBlock.classList.remove('hide-element');

      // Compact helper text under suggestions (no button interaction)
      if (allDone) {
        progressText.textContent = `\u2713 ${t[locale].progressDone}`;
        progressText.classList.add('text-green');
      } else {
        let targetMoods = 3;
        let targetTags = 3;
        let missingMoods = Math.max(0, targetMoods - counts.moods);
        let missingTags = Math.max(0, targetTags - counts.tags);
        let parts = [];
        if (missingMoods > 0) {
          parts.push(`${missingMoods} ${missingMoods === 1 ? t[locale].progressNeedsMoods : t[locale].progressNeedsMoodsPlural}`);
        }
        if (missingTags > 0) {
          parts.push(`${missingTags} ${missingTags === 1 ? t[locale].progressNeedsTags : t[locale].progressNeedsTagsPlural}`);
        }
        if (manualSuggestionDoneState.instruments !== true) {
          parts.push(t[locale].progressFinalizeInstruments);
        }
        progressText.textContent = `${t[locale].progressNeedsPrefix} ${parts.join(` ${t[locale].progressNeedsConnector} `)} ${t[locale].progressNeedsSuffix}`.trim();
        progressText.classList.remove('text-green');
      }

      if (!hasUserInteraction) {
        clearConflictHighlights();
        conflictHint.textContent = '';
        conflictHint.classList.remove('text-red');
        renderSuggestionsLoading();
        return;
      }

      if (skipSuggestionFetchCounter > 0) {
        skipSuggestionFetchCounter -= 1;
        return;
      }

      if (suggestionsContainer) {
        renderSuggestionsLoading();
      }
      fetchConflictsDebounced();
    }

    Object.values(selectors).forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (input) {
        input.addEventListener('change', function () {
          hasUserInteraction = true;
          dismissedSuggestionGroups = {};
          updateSuggestionButtonsState();
          updateInstrumentSuggestionButtonsState();
          sync();
        });
      });
    });

    if (suggestionsContainer) {
      suggestionsContainer.addEventListener('click', function (event) {
        let toggleGroup = event.target.closest('[data-action="trackCategorizationToggleSuggestionGroup"]');
        if (toggleGroup) {
          event.preventDefault();
          let groupKey = toggleGroup.dataset.kindGroup;
          if (!groupKey) return;
          if (!isSuggestionGroupDone(groupKey)) return;
          let isExpanded = !!suggestionGroupExpandedState[groupKey];
          suggestionGroupExpandedState[groupKey] = !isExpanded;
          saveSuggestionGroupExpandedState();
          renderSuggestions(latestSuggestions || {});
          return;
        }

        let noMoreInstore = event.target.closest('[data-action="trackCategorizationMarkNoMoreInstore"]');
        if (noMoreInstore) {
          event.preventDefault();
          manualSuggestionDoneState.instore_tags = true;
          suggestionGroupExpandedState.instore_tags = false;
          saveSuggestionGroupExpandedState();
          renderSuggestions(latestSuggestions || {});
          sync();
          return;
        }

        let noMoreInstruments = event.target.closest('[data-action="trackCategorizationMarkNoMoreInstruments"]');
        if (noMoreInstruments) {
          event.preventDefault();
          manualSuggestionDoneState.instruments = checkedIds(selectors.instruments).length > 0;
          suggestionGroupExpandedState.instruments = false;
          saveSuggestionGroupExpandedState();
          renderSuggestions(latestSuggestions || {});
          sync();
          return;
        }

        let applyOne = event.target.closest('[data-action="trackCategorizationApplySuggestion"]');
        if (applyOne) {
          event.preventDefault();
          let groupKey = applyOne.dataset.kindGroup;
          let currentGroupCount = countAppliedSuggestionsInGroup(groupKey);
          let maxSelection = suggestionGroupSelectionLimit[groupKey] || 2;
          let item = { kind: applyOne.dataset.kind, id: applyOne.dataset.id };
          let input = inputForItem(item);
          if (input && input.checked) {
            skipSuggestionFetchCounter += 1;
            input.checked = false;
            input.dispatchEvent(new Event('change', { bubbles: true }));
            legacyEventHub.trigger('closePopupMenus');
          } else if (input && !input.checked && currentGroupCount < maxSelection) {
            skipSuggestionFetchCounter += 1;
            input.checked = true;
            input.dispatchEvent(new Event('change', { bubbles: true }));
            legacyEventHub.trigger('closePopupMenus');
          }
          updateSuggestionButtonsState();
          return;
        }

        let openDropdown = event.target.closest('[data-action="trackInstrumentSuggestionOpenDropdown"]');
        if (openDropdown) {
          event.preventDefault();
          event.stopPropagation();
          openDropdownForSelector(selectors.instruments);
          return;
        }

        let toggle = event.target.closest('[data-action="trackInstrumentSuggestionToggle"]');
        if (!toggle) return;
        event.preventDefault();
        event.stopPropagation();

        let item = { kind: toggle.dataset.kind, id: toggle.dataset.id };
        let input = inputForItem(item);
        if (!input) return;

        // Keep TagAssist stable (no loading re-render) for local instrument toggles.
        skipSuggestionFetchCounter += 1;
        input.checked = !input.checked;
        input.dispatchEvent(new Event('change', { bubbles: true }));
        legacyEventHub.trigger('closePopupMenus');
        updateInstrumentSuggestionButtonsState();
        return;
      });
    }

    let resetLink = root.querySelector('[data-action~=trackCategorizationReset]');
    if (resetLink) {
      resetLink.addEventListener('click', function (event) {
        event.preventDefault();
        suggestionGroupExpandedState = {};
        manualSuggestionDoneState = {};
        saveSuggestionGroupExpandedState();
        [selectors.genres, selectors.tags, selectors.moods, selectors.instruments, selectors.instore].forEach(function (selector) {
          document.querySelectorAll(selector + ':checked').forEach(function (input) {
            input.checked = false;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          });
        });
        legacyEventHub.trigger('closePopupMenus');
      });
    }

    loadSuggestionGroupExpandedState();
    sync();
  },

  initAlbumCategorizationProgress: function () {
    let root = document.querySelector('[data-action~=initAlbumCategorizationProgress]');
    if (!root) return;

    let progressText = root.querySelector('[data-action~=albumCategorizationProgressText]');
    let progressBlock = root.querySelector('[data-action~=albumCategorizationProgressBlock]');
    let conflictHint = root.querySelector('[data-action~=albumCategorizationConflictHint]');
    let suggestionsContainer = root.querySelector('[data-action~=albumCategorizationSuggestions]');
    if (!progressText || !conflictHint || !suggestionsContainer) return;

    let stepElements = {
      genre: root.querySelector('[data-action~=albumStepGenre]'),
      mood: root.querySelector('[data-action~=albumStepMood]'),
      tags: root.querySelector('[data-action~=albumStepTags]'),
      instruments: root.querySelector('[data-action~=albumStepInstruments]'),
      instore: root.querySelector('[data-action~=albumStepInstore]')
    };

    let selectors = {
      genres: 'input[name="album[genre_ids][]"]',
      tags: 'input[name="album[tag_ids][]"]',
      moods: 'input[name="album[mood_ids][]"]',
      instruments: 'input[name="album[instrument_ids][]"]',
      instore: 'input[name="album[instore_tag_ids][]"]'
    };

    let recommendation = {
      genres: [1, 2],
      tags: [3, 6],
      moods: [3, 4],
      instruments: [2, 4],
      instore: [0, 3]
    };

    let locale = (I18n.locale || 'de').toString().toLowerCase().startsWith('de') ? 'de' : 'en';
    let t = {
      de: {
        guidedNeedGenreMood: 'Schnell und einfach: 1 Genre und 1 Stimmung wählen. Danach kommen die Vorschläge.',
        guidedNeedMood: 'Super. Jetzt bitte 1 Stimmung auswählen.',
        noConflict: 'Keine ungewöhnlichen Kombinationen erkannt.',
        conflictLoading: 'Prüfe Kombinationen…',
        progressDone: 'Fertig, mehr Angaben brauchen wir nicht.',
        progressNeedsPrefix: 'TagAssist Empfehlung:',
        progressNeedsMoods: 'weitere Stimmung',
        progressNeedsMoodsPlural: 'weitere Stimmungen',
        progressNeedsTags: 'weiteres Thema',
        progressNeedsTagsPlural: 'weitere Themen',
        progressNeedsInstruments: 'weiteres Instrument',
        progressNeedsInstrumentsPlural: 'weitere Instrumente',
        progressFinalizeInstruments: 'Instrumente abschließen',
        progressNeedsConnector: 'und',
        progressNeedsSuffix: 'auswählen.',
        suggestionTitle: 'Passende Vorschläge',
        suggestionLimitHint: 'Stimmungen: max. 3, Themen: max. 3, Instrumente: max. 3, Events/Locations: max. 3.',
        suggestionNoFit: 'Alle Möglichkeiten ansehen',
        suggestionCoverageHint: 'Sie haben die empfohlenen Vorschläge übernommen. Weitere Feinabstimmung ist optional.',
        suggestionNoMoreInstruments: 'Keine weiteren Instrumente',
        suggestionNoMoreInstore: 'Keine weiteren Events/Locations'
      },
      en: {
        guidedNeedGenreMood: 'Quick and easy: choose 1 genre and 1 mood. Suggestions follow after that.',
        guidedNeedMood: 'Great. Now choose 1 mood.',
        noConflict: 'No unusual combinations detected.',
        conflictLoading: 'Checking combinations…',
        progressDone: 'Done, no more details needed.',
        progressNeedsPrefix: 'TagAssist recommendation:',
        progressNeedsMoods: 'more mood',
        progressNeedsMoodsPlural: 'more moods',
        progressNeedsTags: 'more topic',
        progressNeedsTagsPlural: 'more topics',
        progressNeedsInstruments: 'more instrument',
        progressNeedsInstrumentsPlural: 'more instruments',
        progressFinalizeInstruments: 'finalize instruments',
        progressNeedsConnector: 'and',
        progressNeedsSuffix: 'to select.',
        suggestionTitle: 'Matching suggestions',
        suggestionLimitHint: 'Moods: max. 3, topics: max. 3, instruments: max. 3, events/locations: max. 3.',
        suggestionNoFit: 'View all options',
        suggestionCoverageHint: 'Recommended suggestions applied. Additional fine-tuning is optional.',
        suggestionNoMoreInstruments: 'No more instruments',
        suggestionNoMoreInstore: 'No more events/locations'
      }
    };

    let selectorByKind = {
      genre: selectors.genres,
      tag: selectors.tags,
      mood: selectors.moods,
      instrument: selectors.instruments,
      instore: selectors.instore
    };
    let selectorBySuggestionGroup = {
      moods: selectors.moods,
      tags: selectors.tags,
      instruments: selectors.instruments,
      instore_tags: selectors.instore
    };
    let suggestionGroupTargets = { moods: 3, tags: 3, instruments: null, instore_tags: 3 };
    let suggestionGroupSelectionLimit = { moods: 3, tags: 3, instruments: 3, instore_tags: 3 };
    function taxonomyConflictsEndpoint() {
      let fromData = root.dataset.taxonomyConflictsPath;
      if (fromData) return fromData;

      let path = window.location.pathname || '';
      if (/\/a\//.test(path)) return '/a/tracks/taxonomy_conflicts';
      if (/\/e\//.test(path)) return '/e/tracks/taxonomy_conflicts';
      return '/m/tracks/taxonomy_conflicts';
    }

    let hasUserInteraction = false;
    let latestSuggestions = {};
    let dismissedSuggestionGroups = {};
    let skipSuggestionFetchCounter = 0;
    let previousCounts = {
      genres: countChecked(selectors.genres),
      moods: countChecked(selectors.moods),
      instruments: countChecked(selectors.instruments)
    };
    let conflictRequestTimer = null;
    let conflictRequestId = 0;
    let suggestionGroupExpandStorageKey = `albumTagAssistExpandedGroups:${window.location.pathname}`;
    let manualSuggestionDoneStorageKey = `albumTagAssistManualDone:${window.location.pathname}`;
    let suggestionGroupExpandedState = {};
    let manualSuggestionDoneState = {};

    function loadSuggestionGroupExpandedState() {
      try {
        suggestionGroupExpandedState = JSON.parse(window.sessionStorage.getItem(suggestionGroupExpandStorageKey) || '{}') || {};
      } catch (_error) {
        suggestionGroupExpandedState = {};
      }
      try {
        manualSuggestionDoneState = JSON.parse(window.sessionStorage.getItem(manualSuggestionDoneStorageKey) || '{}') || {};
      } catch (_error) {
        manualSuggestionDoneState = {};
      }
    }

    function saveSuggestionGroupExpandedState() {
      try {
        window.sessionStorage.setItem(suggestionGroupExpandStorageKey, JSON.stringify(suggestionGroupExpandedState));
      } catch (_error) {}
      try {
        window.sessionStorage.setItem(manualSuggestionDoneStorageKey, JSON.stringify(manualSuggestionDoneState));
      } catch (_error) {}
    }

    function countChecked(selector) { return document.querySelectorAll(selector + ':checked').length; }
    function inRange(value, range) { return value >= range[0] && value <= range[1]; }
    function checkedIds(selector) {
      return Array.from(document.querySelectorAll(selector + ':checked'))
        .map(function (input) { return parseInt(input.value, 10); })
        .filter(function (value) { return !Number.isNaN(value) && value > 0; });
    }
    function inputForItem(item) {
      let selector = selectorByKind[item.kind];
      if (!selector) return null;
      return document.querySelector(`${selector}[value="${item.id}"]`);
    }
    function isSuggestionGroupDone(groupKey) {
      if (groupKey === 'instruments') {
        return manualSuggestionDoneState.instruments === true;
      }
      if (groupKey === 'instore_tags' && manualSuggestionDoneState.instore_tags === true) {
        return true;
      }
      let target = suggestionGroupTargets[groupKey];
      if (!target) return false;
      let selector = selectorBySuggestionGroup[groupKey];
      if (!selector) return false;
      return checkedIds(selector).length >= target;
    }
    function isSuggestionGroupCollapsed(groupKey) {
      return isSuggestionGroupDone(groupKey) && !suggestionGroupExpandedState[groupKey];
    }

    function syncHintStates(doneFlags, counts) {
      Object.keys(hintElements).forEach(function (key) {
        let element = hintElements[key];
        if (!element) return;
        let done = !!doneFlags[key];
        if (key === 'instore') done = manualSuggestionDoneState.instore_tags === true || ((counts.instore || 0) > 0 && done);
        element.classList.toggle('text-green', done);
        element.classList.toggle('text-grey', !done);
      });
    }
    function setStepState(element, state) {
      if (!element) return;
      element.classList.remove('track-step--current', 'track-step--complete', 'track-step--upcoming', 'form-required-callout', 'form-required-callout--success');
      element.classList.add(`track-step--${state}`);

      if (state === 'current') {
        element.classList.add('form-required-callout');
      } else if (state === 'complete') {
        element.classList.add('form-required-callout', 'form-required-callout--success');
      }
    }

    function syncStepStates(counts) {
      let instrumentsDone = manualSuggestionDoneState.instruments === true;

      if (counts.genres === 0) {
        setStepState(stepElements.genre, 'current');
        setStepState(stepElements.mood, 'upcoming');
        setStepState(stepElements.tags, 'upcoming');
        setStepState(stepElements.instruments, 'upcoming');
        setStepState(stepElements.instore, 'upcoming');
        return;
      }

      if (counts.moods === 0) {
        setStepState(stepElements.genre, 'complete');
        setStepState(stepElements.mood, 'current');
        setStepState(stepElements.tags, 'upcoming');
        setStepState(stepElements.instruments, 'upcoming');
        setStepState(stepElements.instore, 'upcoming');
        return;
      }

      if (counts.moods < 3) {
        setStepState(stepElements.genre, 'complete');
        setStepState(stepElements.mood, 'current');
        setStepState(stepElements.tags, 'upcoming');
        setStepState(stepElements.instruments, 'upcoming');
        setStepState(stepElements.instore, 'upcoming');
        return;
      }

      if (counts.tags < 3) {
        setStepState(stepElements.genre, 'complete');
        setStepState(stepElements.mood, 'complete');
        setStepState(stepElements.tags, 'current');
        setStepState(stepElements.instruments, 'upcoming');
        setStepState(stepElements.instore, 'upcoming');
        return;
      }

      if (!instrumentsDone) {
        setStepState(stepElements.genre, 'complete');
        setStepState(stepElements.mood, 'complete');
        setStepState(stepElements.tags, 'complete');
        setStepState(stepElements.instruments, 'current');
        setStepState(stepElements.instore, 'upcoming');
        return;
      }

      setStepState(stepElements.genre, 'complete');
      setStepState(stepElements.mood, 'complete');
      setStepState(stepElements.tags, 'complete');
      setStepState(stepElements.instruments, 'complete');
      setStepState(stepElements.instore, manualSuggestionDoneState.instore_tags === true || counts.instore > 0 ? 'complete' : 'upcoming');
    }

    function countAppliedSuggestionsInGroup(groupKey) {
      if (groupKey === 'instruments') {
        return checkedIds(selectors.instruments).length;
      }
      let selector = selectorBySuggestionGroup[groupKey];
      if (!selector) return 0;
      return checkedIds(selector).length;
    }

    function syncSuggestionGroupUI() {
      suggestionsContainer.querySelectorAll('.track-tagassist__group[data-kind-group]').forEach(function (groupElement) {
        let groupKey = groupElement.dataset.kindGroup;
        if (!groupKey) return;
        let done = isSuggestionGroupDone(groupKey);
        if (!done && suggestionGroupExpandedState[groupKey]) {
          delete suggestionGroupExpandedState[groupKey];
          saveSuggestionGroupExpandedState();
        }
        let collapsed = isSuggestionGroupCollapsed(groupKey);
        groupElement.classList.toggle('track-tagassist__group--done', done);
        groupElement.classList.toggle('track-tagassist__group--collapsed', collapsed);

        let toggleButton = groupElement.querySelector('[data-action="albumCategorizationToggleSuggestionGroup"]');
        if (!toggleButton) return;

        if (done) {
          toggleButton.innerHTML = '<i class="fa fa-check" aria-hidden="true"></i>';
          toggleButton.classList.add('track-tagassist__group-toggle--done');
          toggleButton.classList.remove('track-tagassist__group-toggle--disabled');
          toggleButton.disabled = false;
          toggleButton.setAttribute('aria-disabled', 'false');
        } else {
          toggleButton.innerHTML = '<i class="fa fa-chevron-up" aria-hidden="true"></i>';
          toggleButton.classList.remove('track-tagassist__group-toggle--done');
          toggleButton.classList.add('track-tagassist__group-toggle--disabled');
          toggleButton.disabled = true;
          toggleButton.setAttribute('aria-disabled', 'true');
        }
      });
    }

    function updateSuggestionButtonsState() {
      suggestionsContainer.querySelectorAll('[data-action="albumCategorizationApplySuggestion"]').forEach(function (button) {
        let groupKey = button.dataset.kindGroup;
        let item = { kind: button.dataset.kind, id: button.dataset.id };
        let input = inputForItem(item);
        let isChecked = !!(input && input.checked);
        let groupCount = countAppliedSuggestionsInGroup(groupKey);
        let maxSelection = suggestionGroupSelectionLimit[groupKey] || 2;
        let shouldDisable = !isChecked && groupCount >= maxSelection;

        button.disabled = shouldDisable;
        button.classList.toggle('tag--secondary', isChecked);
        button.classList.toggle('tag--opaque', isChecked);
        button.classList.toggle('tag--primary', !isChecked);
        button.classList.toggle('tag--disabled', shouldDisable);
      });

      syncSuggestionGroupUI();

      suggestionsContainer.querySelectorAll('.track-tagassist__group-counter[data-kind-group]').forEach(function (counter) {
        let groupKey = counter.dataset.kindGroup;
        if (!groupKey) return;
        let selector = groupKey === 'instruments' ? selectors.instruments : selectorBySuggestionGroup[groupKey];
        if (!selector) return;
        let selectedCount = checkedIds(selector).length;
        if (groupKey === 'instruments') {
          counter.textContent = `(${selectedCount})`;
          return;
        }
        let target = suggestionGroupTargets[groupKey] || 3;
        counter.textContent = `(${selectedCount}/${target})`;
      });

      let completionHint = suggestionsContainer.querySelector('[data-action="albumCategorizationSuggestionCompletion"]');
      if (!completionHint) return;
      let allRecommendedApplied = ['moods', 'tags', 'instruments'].every(function (groupKey) {
        return isSuggestionGroupDone(groupKey);
      });
      if (allRecommendedApplied) {
        completionHint.textContent = t[locale].suggestionCoverageHint;
        completionHint.classList.remove('hide-element');
      } else {
        completionHint.textContent = '';
        completionHint.classList.add('hide-element');
      }
    }

    function renderSuggestionsGuidance(message) {
      suggestionsContainer.innerHTML = `<div class="track-tagassist__panel"><p class="text-like-h5 margin-bottom0">${message}</p></div>`;
    }

    function renderSuggestionsLoading() {
      suggestionsContainer.innerHTML = '<div class="track-tagassist__panel"><p class="text-like-h5 margin-bottom0"><i class="fa fa-spinner fa-spin"></i></p></div>';
    }

    function renderSuggestions(suggestions) {
      latestSuggestions = suggestions || {};
      let groups = [
        { key: 'moods', label: I18n.locale === 'de' ? 'Stimmungen' : 'Moods' },
        { key: 'tags', label: I18n.locale === 'de' ? 'Themen' : 'Topics' },
        { key: 'instruments', label: I18n.locale === 'de' ? 'Instrumente' : 'Instruments' },
        { key: 'instore_tags', label: I18n.locale === 'de' ? 'Events/Locations (optional)' : 'Events/locations (optional)' }
      ];
      let hasAny = groups.some(function (group) {
        return !dismissedSuggestionGroups[group.key] && Array.isArray(latestSuggestions[group.key]) && latestSuggestions[group.key].length > 0;
      });
      if (!hasAny) {
        suggestionsContainer.innerHTML = '';
        return;
      }

      let html = `<div class="track-tagassist__panel"><div class="text-like-h5 margin-bottom0">${t[locale].suggestionTitle}</div><div class="text-size-small text-grey margin-top5">${t[locale].suggestionLimitHint}</div>`;
      groups.forEach(function (group) {
        let rows = dismissedSuggestionGroups[group.key] ? [] : (Array.isArray(latestSuggestions[group.key]) ? latestSuggestions[group.key] : []);
        if (group.key === 'instore_tags') rows = rows.slice(0, 9);
        if (rows.length === 0) return;

        let done = isSuggestionGroupDone(group.key);
        if (!done && suggestionGroupExpandedState[group.key]) {
          delete suggestionGroupExpandedState[group.key];
          saveSuggestionGroupExpandedState();
        }
        let collapsed = isSuggestionGroupCollapsed(group.key);
        let iconClass = done ? 'fa-check' : (collapsed ? 'fa-chevron-down' : 'fa-chevron-up');
        let disabledAttr = done ? '' : ' disabled aria-disabled="true"';
        let selector = selectorBySuggestionGroup[group.key];
        let selectedCount = selector ? checkedIds(selector).length : 0;
        let counterText = group.key === 'instruments' ? `${selectedCount}` : `${selectedCount}/3`;
        let counterLabel = `<span class="track-tagassist__group-counter" data-kind-group="${group.key}">(${counterText})</span>`;
        let noMoreInstrumentsChip = '';
        if (group.key === 'instruments') {
          let noMoreClass = done ? ' tag--secondary tag--opaque' : '';
          noMoreInstrumentsChip = `<button type="button" class="tag tag--large tag--text track-tagassist__chip${noMoreClass}" data-action="albumCategorizationMarkNoMoreInstruments"><i class="fa fa-check" aria-hidden="true"></i> ${t[locale].suggestionNoMoreInstruments}</button>`;
        }
        let noMoreInstoreChip = '';
        if (group.key === 'instore_tags' && !done) {
          noMoreInstoreChip = `<button type="button" class="tag tag--large tag--text track-tagassist__chip" data-action="albumCategorizationMarkNoMoreInstore"><i class="fa fa-check" aria-hidden="true"></i> ${t[locale].suggestionNoMoreInstore}</button>`;
        }
        let toggleButton = `<button type="button" class="track-tagassist__group-toggle${done ? ' track-tagassist__group-toggle--done' : ' track-tagassist__group-toggle--disabled'}" data-action="albumCategorizationToggleSuggestionGroup" data-kind-group="${group.key}"${disabledAttr}><i class="fa ${iconClass}" aria-hidden="true"></i></button>`;
        html += `<div class="track-tagassist__group${done ? ' track-tagassist__group--done' : ''}${collapsed ? ' track-tagassist__group--collapsed' : ''}" data-kind-group="${group.key}"><div class="track-tagassist__group-head text-size-small"><span class="text-like-h5 margin-bottom0 track-tagassist__group-title">${toggleButton}${group.label} ${counterLabel}</span></div><div class="track-tagassist__group-body"><div class="track-tagassist__chips">`;
        rows.forEach(function (row) {
          html += `<button type="button" class="tag tag--large tag--interactive track-tagassist__chip" data-action="albumCategorizationApplySuggestion" data-kind-group="${group.key}" data-kind="${row.kind}" data-id="${row.id}">${row.name}</button>`;
        });
        html += noMoreInstrumentsChip;
        html += noMoreInstoreChip;
        html += '</div></div></div>';
      });
      html += '<p class="text-size-small text-grey margin-top10 margin-bottom0 hide-element" data-action="albumCategorizationSuggestionCompletion"></p></div>';
      suggestionsContainer.innerHTML = html;
      updateSuggestionButtonsState();
    }

    function fetchConflictsDebounced() {
      if (conflictRequestTimer) clearTimeout(conflictRequestTimer);
      conflictHint.textContent = t[locale].conflictLoading;
      conflictRequestTimer = setTimeout(function () {
        let requestId = conflictRequestId + 1;
        conflictRequestId = requestId;
        let payload = {
          genre_ids: checkedIds(selectors.genres),
          tag_ids: checkedIds(selectors.tags),
          mood_ids: checkedIds(selectors.moods),
          instore_tag_ids: checkedIds(selectors.instore),
          instrument_ids: checkedIds(selectors.instruments),
          suggestion_context: 'album'
        };
        let csrfTokenMeta = document.querySelector('meta[name="csrf-token"]');
        let csrfToken = csrfTokenMeta ? csrfTokenMeta.getAttribute('content') : null;
        fetch(taxonomyConflictsEndpoint(), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-CSRF-Token': csrfToken },
          credentials: 'same-origin',
          body: JSON.stringify(payload)
        }).then(function (response) {
          if (!response.ok) throw new Error('request_failed');
          return response.json();
        }).then(function (data) {
          if (requestId !== conflictRequestId) return;
          dismissedSuggestionGroups = {};
          let conflicts = Array.isArray(data.conflicts) ? data.conflicts : [];
          conflictHint.textContent = conflicts.length === 0 ? t[locale].noConflict : conflicts.map(function (c) { return c.message; }).join(' ');
          conflictHint.classList.toggle('text-red', conflicts.length > 0);
          renderSuggestions(data.suggestions || {});
        }).catch(function () {
          if (requestId !== conflictRequestId) return;
          dismissedSuggestionGroups = {};
          conflictHint.textContent = t[locale].noConflict;
          conflictHint.classList.remove('text-red');
          renderSuggestions({});
        });
      }, 220);
    }

    function sync() {
      let counts = {
        genres: countChecked(selectors.genres),
        tags: countChecked(selectors.tags),
        moods: countChecked(selectors.moods),
        instruments: countChecked(selectors.instruments),
        instore: countChecked(selectors.instore)
      };

      if (manualSuggestionDoneState.instruments === true && counts.instruments === 0) {
        manualSuggestionDoneState.instruments = false;
        saveSuggestionGroupExpandedState();
      }
      if (counts.genres > previousCounts.genres && counts.genres === 1) {
        legacyEventHub.trigger('closePopupMenus');
      }
      if (counts.moods > previousCounts.moods && counts.moods === 1) {
        legacyEventHub.trigger('closePopupMenus');
      }
      previousCounts = { genres: counts.genres, moods: counts.moods, instruments: counts.instruments };

      let doneFlags = {
        genres: inRange(counts.genres, recommendation.genres),
        tags: inRange(counts.tags, recommendation.tags),
        moods: counts.moods >= 3,
        instruments: manualSuggestionDoneState.instruments === true,
        instore: inRange(counts.instore, recommendation.instore)
      };
      syncStepStates(counts);

      let allDone = counts.genres >= 1 && counts.moods >= 3 && counts.tags >= 3 && manualSuggestionDoneState.instruments === true;
      if (allDone) {
        progressText.textContent = `\u2713 ${t[locale].progressDone}`;
        progressText.classList.add('text-green');
      } else {
        let missingMoods = Math.max(0, 3 - counts.moods);
        let missingTags = Math.max(0, 3 - counts.tags);
        let parts = [];
        if (missingMoods > 0) parts.push(`${missingMoods} ${missingMoods === 1 ? t[locale].progressNeedsMoods : t[locale].progressNeedsMoodsPlural}`);
        if (missingTags > 0) parts.push(`${missingTags} ${missingTags === 1 ? t[locale].progressNeedsTags : t[locale].progressNeedsTagsPlural}`);
        if (manualSuggestionDoneState.instruments !== true) parts.push(t[locale].progressFinalizeInstruments);
        progressText.textContent = `${t[locale].progressNeedsPrefix} ${parts.join(` ${t[locale].progressNeedsConnector} `)} ${t[locale].progressNeedsSuffix}`.trim();
        progressText.classList.remove('text-green');
      }

      let guidedReady = counts.genres >= 1 && counts.moods >= 1;
      if (!guidedReady) {
        if (progressBlock) progressBlock.classList.add('hide-element');
        conflictHint.textContent = '';
        conflictHint.classList.remove('text-red');
        renderSuggestionsGuidance(counts.genres >= 1 && counts.moods === 0 ? t[locale].guidedNeedMood : t[locale].guidedNeedGenreMood);
        return;
      }

      if (progressBlock) progressBlock.classList.remove('hide-element');

      if (!hasUserInteraction) {
        conflictHint.textContent = '';
        conflictHint.classList.remove('text-red');
        renderSuggestionsLoading();
        return;
      }
      if (skipSuggestionFetchCounter > 0) {
        skipSuggestionFetchCounter -= 1;
        return;
      }
      renderSuggestionsLoading();
      fetchConflictsDebounced();
    }

    Object.values(selectors).forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (input) {
        input.addEventListener('change', function () {
          hasUserInteraction = true;
          dismissedSuggestionGroups = {};
          updateSuggestionButtonsState();
          sync();
        });
      });
    });

    suggestionsContainer.addEventListener('click', function (event) {
      let toggleGroup = event.target.closest('[data-action="albumCategorizationToggleSuggestionGroup"]');
      if (toggleGroup) {
        event.preventDefault();
        let groupKey = toggleGroup.dataset.kindGroup;
        if (!groupKey || !isSuggestionGroupDone(groupKey)) return;
        suggestionGroupExpandedState[groupKey] = !suggestionGroupExpandedState[groupKey];
        saveSuggestionGroupExpandedState();
        renderSuggestions(latestSuggestions || {});
        return;
      }

      let noMoreInstore = event.target.closest('[data-action="albumCategorizationMarkNoMoreInstore"]');
      if (noMoreInstore) {
        event.preventDefault();
        manualSuggestionDoneState.instore_tags = true;
        suggestionGroupExpandedState.instore_tags = false;
        saveSuggestionGroupExpandedState();
        renderSuggestions(latestSuggestions || {});
        sync();
        return;
      }

      let noMoreInstruments = event.target.closest('[data-action="albumCategorizationMarkNoMoreInstruments"]');
      if (noMoreInstruments) {
        event.preventDefault();
        manualSuggestionDoneState.instruments = checkedIds(selectors.instruments).length > 0;
        suggestionGroupExpandedState.instruments = false;
        saveSuggestionGroupExpandedState();
        renderSuggestions(latestSuggestions || {});
        sync();
        return;
      }

      let applyOne = event.target.closest('[data-action="albumCategorizationApplySuggestion"]');
      if (!applyOne) return;
      event.preventDefault();
      let groupKey = applyOne.dataset.kindGroup;
      let currentGroupCount = countAppliedSuggestionsInGroup(groupKey);
      let maxSelection = suggestionGroupSelectionLimit[groupKey] || 2;
      let item = { kind: applyOne.dataset.kind, id: applyOne.dataset.id };
      let input = inputForItem(item);
      if (input && input.checked) {
        skipSuggestionFetchCounter += 1;
        input.checked = false;
        input.dispatchEvent(new Event('change', { bubbles: true }));
        legacyEventHub.trigger('closePopupMenus');
      } else if (input && !input.checked && currentGroupCount < maxSelection) {
        skipSuggestionFetchCounter += 1;
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
        legacyEventHub.trigger('closePopupMenus');
      }
      updateSuggestionButtonsState();
    });

    let resetLink = root.querySelector('[data-action~=albumCategorizationReset]');
    if (resetLink) {
      resetLink.addEventListener('click', function (event) {
        event.preventDefault();
        suggestionGroupExpandedState = {};
        manualSuggestionDoneState = {};
        saveSuggestionGroupExpandedState();
        [selectors.genres, selectors.tags, selectors.moods, selectors.instruments, selectors.instore].forEach(function (selector) {
          document.querySelectorAll(selector + ':checked').forEach(function (input) {
            input.checked = false;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          });
        });
        legacyEventHub.trigger('closePopupMenus');
      });
    }

    loadSuggestionGroupExpandedState();
    sync();
  },

  addEventHandlerForMusicSourceSelect: function () {
    let inputElement = document.querySelector('[data-action~=initMusicSourceSelect]'),
        audiocrowdComposerIdInput = document.querySelector('[data-action~=initMusicSourceSelectAudiocrowdComposerId]'),
        audiocrowdTrackIdInput = document.querySelector('[data-action~=initMusicSourceSelectAudiocrowdTrackId]'),
        externalComposerInfoInput = document.querySelector('[data-action~=initMusicSourceSelectExternalComposerInfo]');




    if (inputElement) {
      if (inputElement.value !== 'audiocrowd') {
        if (audiocrowdComposerIdInput && audiocrowdComposerIdInput.value === '') {
          audiocrowdComposerIdInput.parentElement.classList.add('hide-element');
        }
    
        if (audiocrowdTrackIdInput && audiocrowdTrackIdInput.value === '') {
          audiocrowdTrackIdInput.parentElement.classList.add('hide-element');
        }
      }

      if (inputElement.value !== 'external') {
        if (externalComposerInfoInput && externalComposerInfoInput.value === '') {
          externalComposerInfoInput.parentElement.classList.add('hide-element');
        }
      }
  



      inputElement.addEventListener('change', function(e) {
        if (e.target.value === 'audiocrowd') {
          audiocrowdComposerIdInput.parentElement.classList.remove('hide-element');
          audiocrowdTrackIdInput.parentElement.classList.remove('hide-element');
        } else {
          audiocrowdComposerIdInput.parentElement.classList.add('hide-element');
          audiocrowdTrackIdInput.parentElement.classList.add('hide-element');
        }

        if (e.target.value === 'external') {
          externalComposerInfoInput.parentElement.classList.remove('hide-element');
        } else {
          externalComposerInfoInput.parentElement.classList.add('hide-element');
        }
      })
    }
  },

  addEventHandlerForVoiceSourceSelect: function () {
    let inputElement = document.querySelector('[data-action~=initVoiceSourceSelect]'),
        audiocrowdComposerIdInput = document.querySelector('[data-action~=initVoiceSourceSelectAudiocrowdSpeakerId]'),
        externalComposerInfoInput = document.querySelector('[data-action~=initVoiceSourceSelectExternalSpeakerInfo]');


    if (audiocrowdComposerIdInput && audiocrowdComposerIdInput.value === '') {
      audiocrowdComposerIdInput.parentElement.classList.add('hide-element');
    }

    if (externalComposerInfoInput && externalComposerInfoInput.value === '') {
      externalComposerInfoInput.parentElement.classList.add('hide-element');
    }

    if (inputElement) {
      inputElement.addEventListener('change', function(e) {
        if (e.target.value === 'audiocrowd') {
          audiocrowdComposerIdInput.parentElement.classList.remove('hide-element');
        } else {
          audiocrowdComposerIdInput.parentElement.classList.add('hide-element');
        }

        if (e.target.value === 'external') {
          externalComposerInfoInput.parentElement.classList.remove('hide-element');
        } else {
          externalComposerInfoInput.parentElement.classList.add('hide-element');
        }
      })
    }
  },

  initCustomPlaylinks: function () {
    Array.prototype.forEach.call(document.querySelectorAll('[data-action~=playTrack]'), function(element) {
      element.addEventListener('click', function(e) {
        e.preventDefault();
        legacyEventHub.trigger('playTrack', element.getAttribute('data-play-track-id'));
      });
    });

    Array.prototype.forEach.call(document.querySelectorAll('[data-action~=playTrackVariant]'), function(element) {
      element.addEventListener('click', function(e) {
        e.preventDefault();
        legacyEventHub.trigger('playTrackVariant', element.getAttribute('data-play-track-variant-id'));
      });
    });

    Array.prototype.forEach.call(document.querySelectorAll('[data-action~=playSoundEffect]'), function(element) {
      element.addEventListener('click', function(e) {
        e.preventDefault();
        legacyEventHub.trigger('playSoundEffect', element.getAttribute('data-play-sound-effect-id'));
      });
    });

    Array.prototype.forEach.call(document.querySelectorAll('[data-action~=playSpeakerAudio]'), function(element) {
      element.addEventListener('click', function(e) {
        e.preventDefault();

        Array.prototype.forEach.call(document.querySelectorAll('[data-action~=playSpeakerAudio]'), function(node) {
          node.classList.remove('speaker-audio--active');
        });
        element.classList.add('speaker-audio--active');

        legacyEventHub.trigger('playSpeakerAudio', element.getAttribute('data-play-speaker-audio-id'));
      });
    });

    Array.prototype.forEach.call(document.querySelectorAll('[data-action~=playVoiceRecording]'), function(element) {
      element.addEventListener('click', function(e) {
        e.preventDefault();
        legacyEventHub.trigger('playVoiceRecording', element.getAttribute('data-play-voice-recording-id'));
      });
    });

  },

  initSort: function () {
    if (typeof sortable === 'undefined') {
      return;
    }

    sortable('#sortable', {
      items: 'tr'
    });

    let sortableRoots = sortable('#sortable');
    if (typeof sortableRoots[0] != 'undefined') {
      sortableRoots[0].addEventListener('sortupdate', function (e) {

        var elementsArray = Array.prototype.slice.call(this.children);

        var ids = [];

        elementsArray.forEach(function (element) {
          ids.push(element.dataset.id);
        })

        var dataList = ids.map(function (id) {
          return "sortable_element[]=" + id;
        }).join("&")
        var updateUrl = this.dataset.url;
        if (!updateUrl) return;
        var token = csrfToken();
        var headers = {
          'Accept': '*/*',
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
        };
        if (token) {
          headers['X-CSRF-Token'] = token;
        }

        fetch(updateUrl, {
          method: 'PATCH',
          headers: headers,
          body: urlEncodedBody({ sortable_element: ids })
        });
      });
    }
  },


  addEventHandlerForCheckout: function () {
    document.querySelectorAll('[data-action~=removeTrackFromExistingCheckout]').forEach(function (element) {
      if (element.dataset.removeCheckoutLicenseInitialized === 'true') {
        return;
      }

      element.dataset.removeCheckoutLicenseInitialized = 'true';
      element.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();

        let confirmMessage = element.dataset.confirm;
        if (confirmMessage && !window.confirm(confirmMessage)) {
          return;
        }

        let checkoutId = element.dataset.checkoutId;
        let usageLicenseId = element.dataset.usageLicenseId;
        if (!checkoutId || !usageLicenseId) return;

        requestJson("/c/checkouts/" + checkoutId + "/remove_license?id=" + checkoutId + '&usage_license_id=' + usageLicenseId, {
          method: 'POST',
          data: {}
        }).then(function () {
          let checkoutUrl = window.location.origin + '/c/checkouts/' + checkoutId + '/edit_selection';
          window.location.href = checkoutUrl;
        }).catch(function (error) {
          console.error('Could not remove the checkout license.', error);
        });
      });
    });
  },

  initCheckoutProjectQuickLinks: function () {
    let that = this;

    document.querySelectorAll('[data-action~=initCheckoutProjectQuickLinks]').forEach(function (container) {
      if (container.dataset.checkoutProjectQuickLinksInitialized === 'true') {
        return;
      }

      let card = container.closest('.checkout-project-details-card');
      let titleInput = card ? card.querySelector('[name*="[project_name]"]') : null;
      let descriptionInput = card ? card.querySelector('textarea[name*="[project_description]"]') : null;

      if (!card || !titleInput || !descriptionInput) {
        return;
      }

      container.dataset.checkoutProjectQuickLinksInitialized = 'true';

      titleInput.addEventListener('input', function () {
        that.syncCheckoutProjectDetailsContinueButton();
      });
      titleInput.addEventListener('change', function () {
        that.syncCheckoutProjectDetailsContinueButton();
      });

      container.querySelectorAll('[data-action~=checkoutProjectQuickLinkReset]').forEach(function (button) {
        button.addEventListener('click', function (event) {
          event.preventDefault();

          titleInput.value = '';
          descriptionInput.value = '';
          titleInput.dispatchEvent(new Event('input', { bubbles: true }));
          titleInput.dispatchEvent(new Event('change', { bubbles: true }));
          descriptionInput.dispatchEvent(new Event('input', { bubbles: true }));
          descriptionInput.dispatchEvent(new Event('change', { bubbles: true }));

          container.querySelectorAll('[data-action~=checkoutProjectQuickLink]').forEach(function (node) {
            node.classList.remove('checkout-project-details-card__quick-link--selected');
          });

          that.syncCheckoutProjectDetailsContinueButton();
          titleInput.focus();
        });
      });

      container.querySelectorAll('[data-action~=checkoutProjectQuickLink]').forEach(function (button) {
        button.addEventListener('click', function (event) {
          event.preventDefault();

          let projectTitle = button.dataset.projectTitle || '';
          let projectDescription = button.dataset.projectDescription || '';

          titleInput.value = projectTitle;
          descriptionInput.value = projectDescription;
          titleInput.dispatchEvent(new Event('input', { bubbles: true }));
          titleInput.dispatchEvent(new Event('change', { bubbles: true }));
          descriptionInput.dispatchEvent(new Event('input', { bubbles: true }));
          descriptionInput.dispatchEvent(new Event('change', { bubbles: true }));

          container.querySelectorAll('[data-action~=checkoutProjectQuickLink]').forEach(function (node) {
            node.classList.remove('checkout-project-details-card__quick-link--selected');
          });
          button.classList.add('checkout-project-details-card__quick-link--selected');
          titleInput.focus();
          that.syncCheckoutProjectDetailsContinueButton();
        });
      });
    });

    this.syncCheckoutProjectDetailsContinueButton();
  },

  syncCheckoutProjectDetailsContinueButton: function () {
    let button = document.querySelector('[data-checkout-project-details-continue-button]');

    if (!button) {
      return false;
    }

    let disabled = false;

    document.querySelectorAll('.checkout-project-details-card').forEach(function (card) {
      let titleInput = card.querySelector('[name*="[project_name]"]');
      let warning = card.querySelector('[data-action~=checkoutProjectTemplateWarning]');
      let quickLinkTitles = Array.from(card.querySelectorAll('[data-action~=checkoutProjectQuickLink]'))
        .map(function (node) {
          return (node.dataset.projectTitle || '').trim();
        })
        .filter(Boolean);
      let titleValue = titleInput ? titleInput.value.trim() : '';
      let titleMatchesTemplate = titleValue.length > 0 && quickLinkTitles.includes(titleValue);

      if (!titleValue || titleMatchesTemplate) {
        disabled = true;
      }

      if (warning) {
        warning.classList.toggle('hide-element', !titleMatchesTemplate);
      }
    });

    button.disabled = disabled;
    button.classList.toggle('button--disabled', disabled);
    button.setAttribute('aria-disabled', String(disabled));

    return disabled;
  },

  addEventHandlerForPhoneMessageOrderTemplateSelection: function () {
    let parentContainer = document.querySelector('[data-action~=initPhoneOrderTemplateSelection]');

    if (parentContainer) {
      parentContainer.addEventListener('change', function (event) {
        let target = event.target,
          selectNodesInItem,
          selectedSelect,
          textareaInItem,
          notSelectedSelect;

        if (target.nodeName === 'SELECT') {
          selectNodesInItem = target.parentNode.parentNode.parentNode.parentNode.querySelectorAll('select');
          textareaInItem = target.parentNode.parentNode.parentNode.parentNode.querySelector('textarea');
          selectedSelect = target;

          for (var i = 0; i < selectNodesInItem.length; i += 1) {
            if (selectNodesInItem[i] !== selectedSelect) {
              notSelectedSelect = selectNodesInItem[i];
            }
          }

          textareaInItem.innerHTML = selectedSelect.options[selectedSelect.selectedIndex].innerHTML.replace(/#[\d,_A-Z]+\s/i, '');
          notSelectedSelect.selectedIndex = 0;
        }

      });

      if (parentContainer) {
        let form = document.querySelector('form[id*="edit_phone_message_order"]');

        form.querySelector('input[type=submit]').addEventListener('click', function (event) {
          event.preventDefault();
          let selectNodes = parentContainer.querySelectorAll('select');

          for (var j = 0; j < selectNodes.length; j += 1) {
            if (selectNodes[j].selectedIndex === 0) {
              selectNodes[j].remove();
              // selectNodes[j].disabled = true;
            } else {
              // selectNodes[j].disabled = false;
            }
          }

          form.submit();
        });
      }
    }
  },

  initCancellationPolicyForm: function() {
    let cancellationPolicyElement = document.querySelector('[data-action~="initCancellationPolicy"]');

    if (cancellationPolicyElement) {
      let cancellationPolicyForm = new CancellationPolicyForm(cancellationPolicyElement);
    }
  },

  addScrollToEventListener: function () {
    Array.prototype.forEach.call(document.querySelectorAll('a[data-action~="scrollTo"]'), function(element) {
      element.addEventListener('click', function(e) {
        let href = element.getAttribute('href');
        let target = href ? document.querySelector(href) : null;

        if (!target) {
          return;
        }

        e.preventDefault();
        window.scrollTo({
          top: window.scrollY + target.getBoundingClientRect().top - 200,
          behavior: window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
        });
        if (target.getAttribute('tabindex') === '-1' && typeof target.focus === 'function') {
          target.focus({ preventScroll: true });
        }
      });
    });
  },

  currentUserTrackingContext,

  shouldTrackVisitorEvents,

  buildTrackingPayload,

  trackAhoyEvent,

  normalizeTimeValue: function (value) {
    let parsed = parseFloat(value);

    if (isNaN(parsed) || !isFinite(parsed) || parsed < 0) {
      return 0;
    }

    return parsed;
  },

  startPlayTrackingSession: function (trackData, currentTime, duration, freeTrackingMode) {
    let normalizedCurrentTime = this.normalizeTimeValue(currentTime);
    let normalizedDuration = this.normalizeTimeValue(duration);
    let normalizedTrackLength = this.normalizeTimeValue(trackData && trackData.length);
    let resolvedDuration = Math.max(normalizedDuration, normalizedTrackLength);

    this.playTrackingSession = {
      track_id: trackData.id,
      title: trackData.title,
      listened_seconds: 0,
      last_current_time: normalizedCurrentTime,
      max_current_time: normalizedCurrentTime,
      duration_seconds: resolvedDuration,
      track_length_seconds: normalizedTrackLength,
      free_tracking_mode: freeTrackingMode,
      milestones: {}
    };
  },

  updatePlayTrackingSession: function (currentTime, duration) {
    let session = this.playTrackingSession;
    let normalizedCurrentTime;
    let normalizedDuration;
    let delta;

    if (!session) {
      return;
    }

    normalizedCurrentTime = this.normalizeTimeValue(currentTime);
    normalizedDuration = this.normalizeTimeValue(duration);
    session.track_length_seconds = this.normalizeTimeValue(session.track_length_seconds);
    delta = normalizedCurrentTime - session.last_current_time;

    if (delta > 0 && delta <= 5) {
      session.listened_seconds += delta;
    }

    session.last_current_time = normalizedCurrentTime;
    session.max_current_time = Math.max(session.max_current_time, normalizedCurrentTime);

    if (normalizedDuration > 0 || session.track_length_seconds > 0) {
      session.duration_seconds = Math.max(normalizedDuration, session.track_length_seconds);
    }

    this.maybeTrackPlayMilestones();
  },

  maybeTrackPlayMilestones: function () {
    let session = this.playTrackingSession;
    let that = this;
    let milestoneConfig;

    if (!session) {
      return;
    }

    milestoneConfig = [
      { key: '10s', seconds: 10 },
      { key: '30s', seconds: 30 },
      { key: '60s', seconds: 60 }
    ];

    milestoneConfig.forEach(function (milestone) {
      if (!session.milestones[milestone.key] && session.listened_seconds >= milestone.seconds) {
        session.milestones[milestone.key] = true;
        that.trackAhoyEvent('track_play_milestone', withRankingPayload(that.buildTrackingPayload({
          track_id: session.track_id,
          title: session.title,
          location: window.location.href,
          categorization_processed: false
        }, {
          milestone: milestone.key,
          milestone_seconds: milestone.seconds,
          listened_seconds: Number(session.listened_seconds.toFixed(2)),
          duration_seconds: Number(session.duration_seconds.toFixed(2)),
          free_tracking_mode: session.free_tracking_mode
        }), session));
      }
    });

    if (!session.milestones['90pct'] && session.duration_seconds > 0 && (session.max_current_time / session.duration_seconds) >= 0.9) {
      session.milestones['90pct'] = true;
      that.trackAhoyEvent('track_play_milestone', withRankingPayload(that.buildTrackingPayload({
        track_id: session.track_id,
        title: session.title,
        location: window.location.href,
        categorization_processed: false
      }, {
        milestone: '90pct',
        milestone_seconds: Number((session.duration_seconds * 0.9).toFixed(2)),
        listened_seconds: Number(session.listened_seconds.toFixed(2)),
        duration_seconds: Number(session.duration_seconds.toFixed(2)),
        free_tracking_mode: session.free_tracking_mode
      }), session));
    }
  },

  finishPlayTrackingSession: function (reason, endedExplicitly, trackData, currentTime, duration) {
    let session = this.playTrackingSession;
    let completionPercent;
    let completed;

    if (!session) {
      return;
    }

    this.updatePlayTrackingSession(currentTime, duration);
    completionPercent = session.duration_seconds > 0 ? (session.max_current_time / session.duration_seconds) * 100 : 0;
    completed = endedExplicitly || completionPercent >= 99;

    this.trackAhoyEvent('track_play_end', withRankingPayload(this.buildTrackingPayload({
      track_id: session.track_id,
      title: session.title,
      location: window.location.href,
      categorization_processed: false
    }, {
      reason: reason,
      listened_seconds: Number(session.listened_seconds.toFixed(2)),
      max_position_seconds: Number(session.max_current_time.toFixed(2)),
      duration_seconds: Number(session.duration_seconds.toFixed(2)),
      completion_percent: Number(completionPercent.toFixed(2)),
      qualified_play_10s: session.listened_seconds >= 10,
      qualified_play_30s: session.listened_seconds >= 30,
      completed: completed,
      free_tracking_mode: session.free_tracking_mode
    }), session));

    this.playTrackingSession = null;
  },

  addEventHandlerForPlayTracking: function () {
    let that = this;

    legacyEventHub.on('audioPlayerPlay', function () {
      var args = arguments[0] || [],
        trackData = args[0],
        currentTime = args[1],
        duration = args[2],
        shouldTrack = that.shouldTrackVisitorEvents(),
        freeTrackingMode = that.isFreeTrackingModeEnabled(),
        userTrackingContext = that.currentUserTrackingContext();

      if (!trackData || !trackData.id || !shouldTrack) {
        return;
      }

      that.startPlayTrackingSession(trackData, currentTime, duration, freeTrackingMode);

      if (shouldTrack && !freeTrackingMode) {
        if (typeof plausible === 'function') {
          plausible('track_play', { props: buildTrackingPayload({
            track_id: trackData.id,
            title: trackData.title,
            location: window.location.href
          }) });
        }

        that.trackAhoyEvent('track_play', withRankingPayload(that.buildTrackingPayload({
          track_id: trackData.id,
          title: trackData.title,
          location: window.location.href,
          categorization_processed: false
        }), trackData))
      } else if (shouldTrack && freeTrackingMode) {
        if (typeof plausible === 'function') {
          plausible('track_play_free', { props: buildTrackingPayload({
            track_id: trackData.id,
            title: trackData.title,
            location: window.location.href
          }) });
        }

        that.trackAhoyEvent('track_play_free', withRankingPayload(that.buildTrackingPayload({
          track_id: trackData.id,
          title: trackData.title,
          location: window.location.href,
          categorization_processed: false
        }), trackData))
      }

      that.trackAhoyEvent('track_play_start', withRankingPayload(that.buildTrackingPayload({
        track_id: trackData.id,
        title: trackData.title,
        location: window.location.href,
        categorization_processed: false
      }, {
        free_tracking_mode: freeTrackingMode
      }), trackData));
    });

    legacyEventHub.on('audioPlayerTimeUpdate', function () {
      var args = arguments[0] || [];
      that.updatePlayTrackingSession(args[1], args[2]);
    });

    legacyEventHub.on('audioPlayerStop', function () {
      var args = arguments[0] || [];
      that.finishPlayTrackingSession('pause', false, args[0], args[1], args[2]);
    });

    legacyEventHub.on('audioPlayerEnded', function () {
      var args = arguments[0] || [];
      that.finishPlayTrackingSession('ended', true, args[0], args[1], args[2]);
    });
  },

  addEventListenerForNavSearch: function () {
    let searchInput = document.querySelector('.nav__search-input');
    let searchInputWrapper = document.querySelector('.nav__content');

    if (searchInput && searchInputWrapper) {
      searchInput.addEventListener('focus', function () {
        searchInputWrapper.classList.add('nav__content--search-active');
      });

      searchInput.addEventListener('blur', function () {
        searchInputWrapper.classList.remove('nav__content--search-active');
      });
    }
  },

  addEventHandlerForFavoriteTracking: function () {
    let that = this;

    legacyEventHub.on('trackFavorited', function () {
      let favoritePayload = arguments[0][0] || {},
        trackId = typeof favoritePayload === 'object' ? favoritePayload.track_id : favoritePayload,
        shouldTrack = that.shouldTrackVisitorEvents(),
        freeTrackingMode = that.isFreeTrackingModeEnabled();

      if (trackId) {
        if (shouldTrack && !freeTrackingMode) {
          trackCatalogEvent('track_favorite', withRankingPayload({
            track_id: trackId,
            location: window.location.href
          }, favoritePayload));
        } else if (shouldTrack && freeTrackingMode) {
          trackCatalogEvent('track_favorite_free', withRankingPayload({
            track_id: trackId,
            location: window.location.href
          }, favoritePayload));
        }
      }
    });
  },

  addEventHandlerForSoundEffectFavoriteTracking: function () {
    let that = this;

    legacyEventHub.on('soundEffectFavorited', function () {
      let sound_effect_id = arguments[0][0],
        shouldTrack = that.shouldTrackVisitorEvents(),
        freeTrackingMode = that.isFreeTrackingModeEnabled();

      if (sound_effect_id) {
        if (shouldTrack && !freeTrackingMode) {
          trackCatalogEvent('sound_effect_favorite', {
            sound_effect_id,
            location: window.location.href
          });
        } else if (shouldTrack && freeTrackingMode) {
          trackCatalogEvent('sound_effect_favorite_free', {
            sound_effect_id,
            location: window.location.href
          });
        }
      }
    });
  },

  initPriceInfo: function () {
    let priceInfo = new PriceInfo('[data-action~="initPriceInfo"]', {
      currency: I18n.locale === 'de' ? '€' : '$'
    });
  },

  addEventHandlerForCustomTagInput: function () {
    let jquery = this.legacyJQuery();
    if (typeof jquery !== 'function' || !jquery.ui || !jquery.ui.autocomplete) {
      return;
    }

    let $input = jquery('[data-action~=initCustomTagInput]'),
      availableTags;

    function split(val) {
      return val.split(/,\s*/);
    }

    function extractLast(term) {
      return split(term).pop();
    }

    if ($input.length > 0) {
      availableTags = $input.data('autocompletion-suggestions').split(', ');
    }


    jquery('[data-action~=initCustomTagInput]')
      // don't navigate away from the field on tab when selecting an item
      .bind("keydown", function (event) {
        if (event.keyCode === jquery.ui.keyCode.TAB &&
          jquery(this).autocomplete("instance").menu.active) {
          event.preventDefault();
        }
      })
      .autocomplete({
        minLength: 0,
        source: function (request, response) {
          // delegate back to autocomplete, but extract the last term
          response(jquery.ui.autocomplete.filter(
            availableTags, extractLast(request.term)).slice(0, 20));

        },
        focus: function () {
          // prevent value inserted on focus
          return false;
        },
        select: function (event, ui) {
          var terms = split(this.value);
          // remove the current input
          terms.pop();
          // add the selected item
          terms.push(ui.item.value);
          // add placeholder to get the comma-and-space at the end
          terms.push("");
          this.value = terms.join(", ");
          return false;
        }
      });
  },

  initAlbumTrackMappingSearch: function () {
    let jquery = this.legacyJQuery();
    if (typeof jquery !== 'function' || !jquery.ui || !jquery.ui.autocomplete) {
      return;
    }

    let $inputs = jquery('[data-action~=albumTrackMappingSearch]');

    if (!$inputs.length) {
      return;
    }

    $inputs.each(function () {
      let input = this;

      if (input.dataset.autocompleteBound === '1') {
        return;
      }

      input.dataset.autocompleteBound = '1';

      jquery(input).autocomplete({
        minLength: 2,
        source: function (request, response) {
          let url = input.dataset.albumTrackMappingSearchUrl;
          if (!url) {
            response([]);
            return;
          }

          jquery.getJSON(url, { q: request.term })
            .done(function (items) {
              response((items || []).map(function (item) {
                return {
                  label: item.label,
                  value: item.label,
                  id: item.id
                };
              }));
            })
            .fail(function () {
              response([]);
            });
        },
        select: function (_event, ui) {
          let row = input.closest('.fields');
          let hiddenTrackIdInput = row && row.querySelector('input[type=hidden][data-album-track-mapping-track-id]');
          if (hiddenTrackIdInput) {
            hiddenTrackIdInput.value = ui.item.id;
          }
          input.value = ui.item.label;
          return false;
        },
        change: function (_event, ui) {
          let row = input.closest('.fields');
          let hiddenTrackIdInput = row && row.querySelector('input[type=hidden][data-album-track-mapping-track-id]');

          if (!hiddenTrackIdInput) {
            return;
          }

          if (!ui.item && input.value.trim().length === 0) {
            hiddenTrackIdInput.value = '';
          } else if (!ui.item) {
            hiddenTrackIdInput.value = '';
          }
        }
      });
    });
  },


  addEventHandlerForTrackFormSubmit: function () {
    let jquery = this.legacyJQuery();
    if (typeof jquery !== 'function') {
      return;
    }

    let $forms = jquery('.track-form form, .sound_effect-form form');
    if (!$forms.length) {
      return;
    }

    let that = this;

    $forms.on('submit', function (event) {
      let formElement = this;
      let trackFormWrapper = jquery(this).closest('.track-form');
      let soundEffectFormWrapper = jquery(this).closest('.sound_effect-form');
      let overlayDisabled = trackFormWrapper.attr('data-disable-submit-overlay') === 'true' ||
        soundEffectFormWrapper.attr('data-disable-submit-overlay') === 'true';
      let validationError = that.validatePrimaryDirectUploadSubmit(formElement);

      that.setPrimaryDirectUploadFormError(formElement, '');

      if (validationError) {
        event.preventDefault();
        that.hideOverlay();
        that.setPrimaryDirectUploadFormError(formElement, validationError);
        return false;
      }

      if (soundEffectFormWrapper.length > 0 || overlayDisabled) {
        return true;
      }

      var message = trackFormWrapper.attr('data-upload-text');
      var heading = trackFormWrapper.attr('data-upload-heading');

      that.showOverlay({
        'heading': heading,
        'message': message,
        'icon': 'fa-cog fa-spin'
      });
    });
  },

  showOverlay: function (options) {
    if (options === undefined) {
      options = {};
    }

    if (options['icon'] === undefined) {
      options['icon'] = 'fa-info';
    }

    if (options['heading'] === undefined) {
      // TODO: Implement localization
      options['heading'] = "Please wait";
    }

    if (options['message'] === undefined) {
      // TODO: Implement localization
      options['message'] = "Please wait";
    }

    let overlay = document.querySelector('.overlay-wrapper');
    if (!overlay) {
      this.initOverlay();
      overlay = document.querySelector('.overlay-wrapper');
    }
    if (!overlay) {
      return;
    }

    let messageNode = overlay.querySelector('.overlay-message');
    let headingNode = overlay.querySelector('.overlay-heading');
    let iconNode = overlay.querySelector('.overlay-icon i');

    if (messageNode) messageNode.textContent = options['message'];
    if (headingNode) headingNode.textContent = options['heading'];
    if (iconNode) iconNode.className = 'fa ' + options['icon'];

    overlay.style.display = 'block';
  },

  hideOverlay: function () {
    let overlay = document.querySelector('.overlay-wrapper');
    if (!overlay) return;

    overlay.style.display = 'none';
  },

  initOverlay: function () {
    if (document.querySelector('.overlay-wrapper')) return;

    let overlay = document.createElement('div');
    overlay.className = 'overlay-wrapper';
    overlay.style.display = 'none';
    overlay.innerHTML = '<div class="overlay-message-wrapper"><p class="overlay-icon"><i class="fa"></i></p><h2 class="overlay-heading"></h2><p class="overlay-message"></p></div>';
    document.body.appendChild(overlay);
  },

  initPendingDemoDownloadOverlay: function () {
    let overlay = document.querySelector('[data-demo-download-ready-overlay]');
    if (!overlay) {
      return;
    }

    let startButton = overlay.querySelector('[data-action~=demoDownloadReadyStart]');
    if (!startButton) {
      return;
    }

    let downloadUrl = startButton.getAttribute('data-demo-download-url');
    let trackId = startButton.getAttribute('data-demo-download-track-id');
    let trackVariantId = startButton.getAttribute('data-demo-download-track-variant-id');
    if (!downloadUrl || !trackId) return;

    function closeOverlay() {
      if (overlay.parentNode) {
        overlay.parentNode.removeChild(overlay);
      }
    }

    function triggerBackgroundDownload(url) {
      let frame = document.querySelector('[data-demo-download-frame]');
      if (!frame) {
        frame = document.createElement('iframe');
        frame.setAttribute('data-demo-download-frame', 'true');
        frame.setAttribute('title', 'demo-download-frame');
        frame.style.display = 'none';
        document.body.appendChild(frame);
      }

      frame.setAttribute('src', url);
    }

    overlay.querySelectorAll('[data-action~=demoDownloadReadyClose]').forEach(function (element) {
      element.addEventListener('click', function (event) {
        event.preventDefault();
        closeOverlay();
      });
    });

    startButton.addEventListener('click', function (event) {
      event.preventDefault();
      trackCatalogEvent('track_layout_download', buildTrackingPayload({
        track_id: parseInt(trackId, 10),
        track_variant_id: trackVariantId ? parseInt(trackVariantId, 10) : undefined,
        location: window.location.href
      }));
      triggerBackgroundDownload(downloadUrl);
      closeOverlay();
    });
    startButton.focus();
  },

  addEventHandlerForGlobalCloseClick: function () {
    let element = document.querySelector('[data-action~=global-close-click]');
    element.addEventListener('click', function (e) {
      if (shouldClosePopupMenus(e.target)) {
        legacyEventHub.trigger('closePopupMenus');
      }
    })
  },

  validatePrimaryDirectUploadSubmit: function (formElement) {
    if (!formElement) return null;

    let pending = parseInt(formElement.dataset.directUploadPending || '0', 10);
    if (!Number.isNaN(pending) && pending > 0) {
      return I18n.locale === 'de'
        ? 'Der Upload ist noch nicht abgeschlossen. Bitte warten Sie einen Moment und versuchen Sie es dann erneut.'
        : 'The upload is still in progress. Please wait a moment and try again.';
    }

    let uploadInputs = Array.from(formElement.querySelectorAll('input[type="file"][data-direct-upload-primary-target]'));
    if (!uploadInputs.length) return null;

    let hasBrokenUpload = uploadInputs.some(function (inputNode) {
      let targetName = inputNode.getAttribute('data-direct-upload-primary-target') || '';
      if (targetName.length === 0) return false;

      let hiddenFieldPresent = Array.from(formElement.querySelectorAll('input[type="hidden"]')).some(function (hiddenNode) {
        return hiddenNode.name === targetName && String(hiddenNode.value || '').length > 0;
      });
      if (hiddenFieldPresent) return false;

      let hasSelectedLocalFile = !!(inputNode.files && inputNode.files.length > 0);
      let uploadCompleted = inputNode.dataset.directUploadCompleted === '1';

      return hasSelectedLocalFile || uploadCompleted;
    });

    if (!hasBrokenUpload) return null;

    return I18n.locale === 'de'
      ? 'Der Datei-Upload wurde nicht sauber übernommen. Bitte laden Sie die Datei erneut hoch und speichern Sie erst danach.'
      : 'The file upload was not transferred cleanly. Please upload the file again and save only afterward.';
  },

  setPrimaryDirectUploadFormError: function (formElement, message) {
    if (!formElement) return;

    let errorNode = formElement.querySelector('[data-action~=directUploadFormError]');
    if (!errorNode) return;

    let hasMessage = !!(message && String(message).trim().length > 0);
    errorNode.textContent = hasMessage ? message : '';
    errorNode.classList.toggle('hide-element', !hasMessage);
  },

  initDirectFileUpload: function () {
    let jquery = this.legacyJQuery();
    if (typeof jquery !== 'function') {
      return;
    }

    jquery('.directUpload').find('input:file').each(function (i, elem) {
      if (!elem.classList.contains('directUploadIgnore')) {
        var formElement = elem.closest('form');
        var isBulkTracksForm = formElement && formElement.classList.contains('directUpload--bulk-tracks');
        this.initDirectFileUploadElement(elem, !!isBulkTracksForm);

        // var fileInput = $(elem);
        // var form = $(fileInput.parents('form:first'));
        // var submitButton = form.find('input[type="submit"]');
        // var progressBar = $('<div class="bar"></div>');
        // var barContainer = $('<div class="progress"></div>').append(progressBar);
        // fileInput.after(barContainer);
        // fileInput.fileupload({
        //     fileInput: fileInput,
        //     url: form.data('url'),
        //     type: 'POST',
        //     autoUpload: true,
        //     formData: form.data('form-data'),
        //     paramName: 'file', // S3 does not like nested name fields i.e. name="user[avatar_url]"
        //     dataType: 'XML',  // S3 returns XML if success_action_status is set to 201
        //     replaceFileInput: false,
        //     progressall: function (e, data) {
        //         var progress = parseInt(data.loaded / data.total * 100, 10);
        //         progressBar.css('width', progress + '%');
        //     },
        //     start: function () {
        //         submitButton.prop('disabled', true);

        //         progressBar.
        //             css('background', 'green').
        //             css('display', 'block').
        //             css('width', '0%').
        //             text('Uploading...');
        //     },
        //     done: function (e, data) {
        //         submitButton.prop('disabled', false);
        //         progressBar.text('Uploading done');

        //         // extract key and generate URL from response
        //         var key = $(data.jqXHR.responseXML).find('Key').text();
        //         var url = '//' + form.data('host') + '/' + key;

        //         // create hidden field
        //         var input = $('<input />', { type: 'hidden', name: fileInput.attr('name'), value: url });
        //         form.append(input);

        //         // remove file upload element to avoid duplicate upload time
        //         fileInput.fadeOut(1000, function () { fileInput.remove(); });
        //     },
        //     fail: function (e) {
        //         submitButton.prop('disabled', false);

        //         progressBar.
        //             css('background', 'red').
        //             text('Upload failed');
        //     }
        // });

      }
    }.bind(this));

    jquery(document).on('nested:fieldAdded', function (event) {
      var field = event.field;
      if (field.closest('form')[0].classList.contains('directUpload') && !field.closest('form')[0].classList.contains('directUpload--bulk-tracks')) {
        var inputElement = field[0].querySelector('input[type="file"]')
        this.initDirectFileUploadElement(inputElement, false);
      } else if (field.closest('form')[0].classList.contains('directUpload') && field.closest('form')[0].classList.contains('directUpload--bulk-tracks')) {
        var inputElement = field[0].querySelector('input[type="file"]')
        this.initDirectFileUploadElement(inputElement, true);
        this.bulkTrackUploadManager.consumePendingForField(field[0]);
      }

      // Auto fill position
      var currentPositionInput = field[0].querySelector('input[name$="[position]"]');
      var formerPositionInput = field[0].previousElementSibling && field[0].previousElementSibling.querySelector('input[name$="[position]"]');

      if (currentPositionInput && currentPositionInput.value.length === 0) {
        if (formerPositionInput) {
          if (formerPositionInput.value.length === 0) {
            currentPositionInput.value = 1;
          } else {
            currentPositionInput.value = parseInt(formerPositionInput.value, 10) + 1;
          }
        } else {
          currentPositionInput.value = 1;
        }
      }

      if (this.bulkTrackUploadManager) {
        this.bulkTrackUploadManager.initSorting();
      }

      this.initAlbumTrackMappingSearch();

    }.bind(this));
  },

  initTrackMainUploadDropzone: function () {
    let dropzones = document.querySelectorAll('[data-track-main-dropzone]');
    if (!dropzones.length) return;

    dropzones.forEach(function (dropzone) {
      let form = dropzone.closest('form');
      let picker = dropzone.querySelector('[data-track-main-file-picker]');
      let feedback = dropzone.querySelector('[data-track-main-picker-feedback]');

      if (!form || !picker) return;

      let getTargetInput = function () {
        return form.querySelector('input[type="file"][name="track[s3_file_upload_url]"]');
      };

      let writeFeedback = function (message) {
        if (feedback) feedback.textContent = message;
      };

      let isAllowedMainUploadFile = function (file) {
        if (!file || !file.name) return false;
        let lowerName = String(file.name).toLowerCase();
        let validByExtension = lowerName.endsWith('.wav');
        let mime = String(file.type || '').toLowerCase();
        let validByMime = mime === '' || mime === 'audio/wav' || mime === 'audio/x-wav' || mime === 'audio/wave';
        return validByExtension && validByMime;
      };

      let assignAndUpload = function (file) {
        let targetInput = getTargetInput();
        if (!targetInput) {
          writeFeedback(I18n.locale === 'de' ? 'Upload bereits gesetzt. Bitte Seite neu laden, um erneut hochzuladen.' : 'Upload already set. Reload page to upload again.');
          return;
        }

        if (!file) return;
        if (!isAllowedMainUploadFile(file)) {
          writeFeedback(I18n.locale === 'de' ? 'Bitte nur WAV-Dateien hochladen.' : 'Please upload WAV files only.');
          return;
        }

        if (typeof DataTransfer !== 'undefined') {
          let dt = new DataTransfer();
          dt.items.add(file);
          targetInput.files = dt.files;
        }
        $(targetInput).trigger('change');
      };

      dropzone.addEventListener('click', function (event) {
        if (event.target === picker) return;
        picker.click();
      });

      picker.addEventListener('change', function (event) {
        let file = event.target.files && event.target.files[0];
        assignAndUpload(file);
        event.target.value = '';
      });

      dropzone.addEventListener('dragover', function (event) {
        event.preventDefault();
        event.stopPropagation();
        if (event.dataTransfer) event.dataTransfer.dropEffect = 'copy';
        dropzone.classList.add('is-dragover');
      });

      dropzone.addEventListener('dragenter', function (event) {
        event.preventDefault();
        event.stopPropagation();
        dropzone.classList.add('is-dragover');
      });

      dropzone.addEventListener('dragleave', function (event) {
        event.preventDefault();
        event.stopPropagation();
        if (event.target === dropzone) {
          dropzone.classList.remove('is-dragover');
        }
      });

      dropzone.addEventListener('drop', function (event) {
        event.preventDefault();
        event.stopPropagation();
        dropzone.classList.remove('is-dragover');
        let file = event.dataTransfer && event.dataTransfer.files ? event.dataTransfer.files[0] : null;
        assignAndUpload(file);
      });
    });
  },

  initSingleFileUploadDropzones: function () {
    let dropzones = document.querySelectorAll('[data-single-file-upload-dropzone]');
    if (!dropzones.length) return;

    dropzones.forEach(function (dropzone) {
      let form = dropzone.closest('form');
      let picker = dropzone.querySelector('[data-single-file-upload-picker]');
      let feedback = dropzone.querySelector('[data-single-file-upload-feedback]');
      let targetInputName = dropzone.getAttribute('data-single-file-upload-target-input-name') || '';
      let allowedExtension = (dropzone.getAttribute('data-single-file-upload-allowed-extension') || '').toLowerCase();
      let allowedMimeList = (dropzone.getAttribute('data-single-file-upload-allowed-mime-list') || '')
        .split(',')
        .map(function (entry) { return entry.trim().toLowerCase(); })
        .filter(function (entry) { return entry.length > 0; });
      let invalidTypeMessage = dropzone.getAttribute('data-single-file-upload-invalid-type-message') || '';
      let uploadAlreadySetMessage = dropzone.getAttribute('data-single-file-upload-already-set-message') || '';

      if (!form || !picker || targetInputName.length === 0) return;

      let getTargetInput = function () {
        return form.querySelector('input[type="file"][name="' + targetInputName + '"]');
      };

      let writeFeedback = function (message) {
        if (feedback) feedback.textContent = message || '';
      };

      let isAllowedFile = function (file) {
        if (!file || !file.name) return false;

        let lowerName = String(file.name).toLowerCase();
        let validByExtension = allowedExtension.length === 0 || lowerName.endsWith(allowedExtension);
        let mime = String(file.type || '').toLowerCase();
        let validByMime = mime === '' || allowedMimeList.length === 0 || allowedMimeList.includes(mime);

        return validByExtension && validByMime;
      };

      let assignAndUpload = function (file) {
        let targetInput = getTargetInput();
        if (!targetInput) {
          writeFeedback(uploadAlreadySetMessage);
          return;
        }

        if (!file) return;
        if (!isAllowedFile(file)) {
          writeFeedback(invalidTypeMessage);
          return;
        }

        writeFeedback('');

        if (typeof DataTransfer !== 'undefined') {
          let dt = new DataTransfer();
          dt.items.add(file);
          targetInput.files = dt.files;
        }
        $(targetInput).trigger('change');
      };

      dropzone.addEventListener('click', function (event) {
        if (event.target === picker) return;
        picker.click();
      });

      picker.addEventListener('change', function (event) {
        let file = event.target.files && event.target.files[0];
        assignAndUpload(file);
        event.target.value = '';
      });

      dropzone.addEventListener('dragover', function (event) {
        event.preventDefault();
        event.stopPropagation();
        if (event.dataTransfer) event.dataTransfer.dropEffect = 'copy';
        dropzone.classList.add('is-dragover');
      });

      dropzone.addEventListener('dragenter', function (event) {
        event.preventDefault();
        event.stopPropagation();
        dropzone.classList.add('is-dragover');
      });

      dropzone.addEventListener('dragleave', function (event) {
        event.preventDefault();
        event.stopPropagation();
        if (event.target === dropzone) {
          dropzone.classList.remove('is-dragover');
        }
      });

      dropzone.addEventListener('drop', function (event) {
        event.preventDefault();
        event.stopPropagation();
        dropzone.classList.remove('is-dragover');
        let file = event.dataTransfer && event.dataTransfer.files ? event.dataTransfer.files[0] : null;
        assignAndUpload(file);
      });
    });
  },

  initDirectFileUploadElement: function (fileInputElement, bulkUploadMode) {
    let jquery = this.legacyJQuery();
    if (typeof jquery !== 'function' || !jquery.fn || typeof jquery.fn.fileupload !== 'function') {
      return;
    }

    let moduleRef = this;
    let bulkManager = this.bulkTrackUploadManager;
    var fileInput = jquery(fileInputElement);
    var form = jquery(fileInput.parents('form:first'));
    var formElement = form[0];
    var secureAudioUpload = !!(formElement && formElement.dataset && formElement.dataset.secureAudioUpload === 'true');
    var privateS3Upload = !!(formElement && formElement.dataset && formElement.dataset.privateS3Upload === 'true');
    var originalInputName = fileInput.attr('name');
    var effectiveBulkUploadMode = !!bulkUploadMode || !!(fileInputElement && fileInputElement.dataset && fileInputElement.dataset.bulkTrackFileInput !== undefined);
    var isComposerTrackMainUpload = fileInput.attr('name') === 'track[s3_file_upload_url]';
    var progressBar = jquery('<div class="bar"></div>');
    var barContainer = jquery('<div class="progress"></div>').append(progressBar);
    var currentUploadFileName = '';
    var speakerAudioUpload = !!(formElement && formElement.dataset && formElement.dataset.speakerAudioUpload === 'true');
    var speakerAudioProgress = formElement && formElement.querySelector('[data-action~=speakerAudioUploadProgress]');
    var speakerAudioStatus = formElement && formElement.querySelector('[data-action~=speakerAudioUploadStatus]');

    var updateSpeakerAudioUploadState = function (progress, state) {
      if (!speakerAudioUpload) return;

      if (speakerAudioProgress) {
        speakerAudioProgress.hidden = false;
        speakerAudioProgress.value = progress;
      }

      if (!speakerAudioStatus) return;

      var german = (I18n.locale || '').toString().toLowerCase().startsWith('de');
      var messages = {
        uploading: german ? 'Upload läuft …' : 'Upload in progress …',
        uploaded: german ? 'Upload abgeschlossen. Die Hörprobe wird jetzt verarbeitet.' : 'Upload complete. The audio demo is now being processed.',
        failed: german ? 'Upload fehlgeschlagen. Bitte versuchen Sie es erneut.' : 'Upload failed. Please try again.'
      };
      speakerAudioStatus.textContent = messages[state] || '';
    };

    if (fileInputElement && originalInputName) {
      fileInputElement.dataset.directUploadCompleted = '0';
    }

    fileInput.after(barContainer);
    fileInput.fileupload({
      fileInput: fileInput,
      url: form.data('url'),
      type: 'POST',
      autoUpload: true,
      formData: (form.data('form-data') || {}),
      paramName: 'file', // S3 does not like nested name fields i.e. name="user[avatar_url]"
      dataType: 'XML',  // S3 returns XML if success_action_status is set to 201
      replaceFileInput: false,
      progressall: function (e, data) {
        var progress = parseInt(data.loaded / data.total * 100, 10);
        progressBar.css('width', progress + '%');
        updateSpeakerAudioUploadState(progress, 'uploading');
        if (effectiveBulkUploadMode) {
          moduleRef.setBulkUploadRowUploadingState(fileInput[0], {
            uploading: true,
            fileName: currentUploadFileName,
            progress: progress
          });
        }
      },

      add: function(e, data){
        let formDataAttributes = Object.assign({}, form.data('form-data'));

        bulkManager.prepareAddData({
          bulkUploadMode: effectiveBulkUploadMode,
          data: data,
          formElement: form[0]
        });

        console.log('directFileUpload this:', this);
        console.log('directFileUpload this.value:', this.value);

        let fileName = (data.files && data.files[0] && data.files[0].name) ? data.files[0].name : '';
        if (fileName.length === 0 && this.value) {
          fileName = this.value.split(/[\\]+/).pop();
        }
        console.log('directFileUpload fileName:', fileName);

        if (typeof fileName === 'undefined' || fileName.length == 0) {
          fileName = 'fallback_filename_' + Math.random().toString(36).slice(2, 7) + '.wav'
          console.log('directFileUpload fallbackFileName:', fileName);
        }

        let sanitizedFileName = Helpers.sanitizeFileName(fileName);
        console.log('directFileUpload sanitizedFileName:', sanitizedFileName);

        let initialKey = (formDataAttributes.key || '').replace('${filename}', sanitizedFileName);
        formDataAttributes.key = initialKey;

        console.log('initialKey', initialKey);

        let newKey = formDataAttributes.key.replace(/\/([A-Za-z0-9])\w+.wav/, '/' + sanitizedFileName);
        formDataAttributes.key = newKey;

        console.log('newKey', newKey);

        data.formData = formDataAttributes;
        currentUploadFileName = (data.files && data.files[0] && data.files[0].name) ? data.files[0].name : sanitizedFileName;
        console.log('data:', data);
        data.submit();
      },
      start: function () {
        if (fileInputElement && originalInputName) {
          fileInputElement.dataset.directUploadCompleted = '0';
        }
        moduleRef.incrementDirectUploadPending(formElement);
        if (effectiveBulkUploadMode) {
          moduleRef.setBulkUploadRowUploadedPreviewState(fileInput[0], { visible: false });
          moduleRef.setBulkUploadRowUploadingState(fileInput[0], {
            uploading: true,
            fileName: currentUploadFileName,
            progress: 0
          });
        }
        if (!effectiveBulkUploadMode && isComposerTrackMainUpload) {
          moduleRef.setTrackAutofillHintState(formElement, 'uploading');
          moduleRef.setTrackAutofillFieldLoading(formElement, true);
        }

        progressBar.
          css('background', 'green').
          css('display', 'block').
          css('width', '0%').
          text('Uploading...');
        updateSpeakerAudioUploadState(0, 'uploading');
      },
      done: function (e, data) {
        var file = data.files[0];
        bulkManager.releaseAssignedInput(fileInput[0], effectiveBulkUploadMode);

        console.log('directFileUpload done file:', file);

        // Exclude the original file input from the final Rails form submit immediately.
        // Otherwise the browser can still submit the raw file field alongside the hidden S3 URL.
        fileInput.prop('disabled', true);
        fileInput.removeAttr('name');
        try {
          fileInput.val('');
        } catch (error) {
          console.log('directFileUpload clear input failed:', error);
        }

        moduleRef.decrementDirectUploadPending(formElement);
        progressBar.text(file['name']);
        updateSpeakerAudioUploadState(100, 'uploaded');
        if (effectiveBulkUploadMode) {
          moduleRef.setBulkUploadRowUploadingState(fileInput[0], {
            uploading: false,
            fileName: file && file.name ? file.name : currentUploadFileName,
            progress: 100
          });
        }

        BulkTrackAudioAnalysis.apply({
          file: file,
          fileInputElement: fileInput[0],
          barContainerElement: barContainer[0]
        });

        // extract key and generate URL from response
        var key = $(data.jqXHR.responseXML).find('Key').text();
        var url = '//' + form.data('host') + '/' + key;

        console.log('key: ', key);
        console.log('url: ', url);
        console.log('file:', file)

        if (effectiveBulkUploadMode) {
          var displayTitle = moduleRef.resolveBulkUploadDisplayTitle(fileInput[0], file);
          moduleRef.setBulkUploadRowUploadedPreviewState(fileInput[0], {
            visible: true,
            fileName: displayTitle,
            url: url
          });
          barContainer.hide();
        }


        // create hidden field
        var input = $('<input />', { type: 'hidden', name: originalInputName, value: (secureAudioUpload || privateS3Upload) ? key : url });
        form.append(input);
        if (fileInputElement && originalInputName) {
          fileInputElement.dataset.directUploadCompleted = '1';
        }
        moduleRef.setPrimaryDirectUploadFormError(formElement, '');

        if (!effectiveBulkUploadMode && isComposerTrackMainUpload) {
          moduleRef.setTrackAutofillFieldLoading(formElement, false);
          moduleRef.setTrackAutofillHintState(formElement, 'ready');
          moduleRef.showTrackDirectUploadPreview(formElement, url, file && file.name);
          moduleRef.markTrackDirectUploadUnsaved(formElement, true);
        }

        console.log('directFileUpload hidden_input:', input[0]);


        // remove file upload element to avoid duplicate upload time
        fileInput.fadeOut(1000, function () { fileInput.remove(); });
      },
      fail: function (e) {
        if (fileInputElement && originalInputName) {
          fileInputElement.dataset.directUploadCompleted = '0';
        }
        bulkManager.releaseAssignedInput(fileInput[0], effectiveBulkUploadMode);
        moduleRef.decrementDirectUploadPending(formElement);
        if (effectiveBulkUploadMode) {
          moduleRef.setBulkUploadRowUploadingState(fileInput[0], {
            uploading: false,
            fileName: currentUploadFileName,
            progress: 0
          });
          moduleRef.setBulkUploadRowUploadedPreviewState(fileInput[0], { visible: false });
        }
        if (!effectiveBulkUploadMode && isComposerTrackMainUpload) {
          moduleRef.setTrackAutofillFieldLoading(formElement, false);
          moduleRef.setTrackAutofillHintState(formElement, 'hidden');
        }

        progressBar.
          css('background', 'red').
          text('Upload failed');
        updateSpeakerAudioUploadState(0, 'failed');
      }
    });
  },

  ensureBulkUploadRowStatusElement: function (fileInputElement) {
    var fieldRow = fileInputElement && fileInputElement.closest('.fields');
    if (!fieldRow) return null;

    var existing = fieldRow.querySelector('[data-action~=bulkUploadRowStatus]');
    if (existing) return existing;

    var status = document.createElement('div');
    status.className = 'bulk-track-upload__uploading-status hide-element';
    status.setAttribute('data-action', 'bulkUploadRowStatus');
    status.innerHTML = '' +
      '<div class="bulk-track-upload__uploading-file" data-action="bulkUploadRowStatusFile"></div>' +
      '<div class="bulk-track-upload__uploading-progress">' +
      '  <div class="bulk-track-upload__uploading-progress-bar" data-action="bulkUploadRowStatusBar"></div>' +
      '</div>' +
      '<div class="bulk-track-upload__uploading-percent" data-action="bulkUploadRowStatusPercent">0%</div>';

    fieldRow.insertBefore(status, fieldRow.firstChild);
    return status;
  },

  setBulkUploadRowUploadingState: function (fileInputElement, options) {
    var fieldRow = fileInputElement && fileInputElement.closest('.fields');
    if (!fieldRow) return;

    var status = this.ensureBulkUploadRowStatusElement(fileInputElement);
    if (!status) return;

    var fileNode = status.querySelector('[data-action~=bulkUploadRowStatusFile]');
    var barNode = status.querySelector('[data-action~=bulkUploadRowStatusBar]');
    var percentNode = status.querySelector('[data-action~=bulkUploadRowStatusPercent]');
    var uploading = !!(options && options.uploading);
    var progress = options && typeof options.progress === 'number' ? Math.max(0, Math.min(100, options.progress)) : 0;
    var fileName = options && options.fileName ? options.fileName : '';

    if (fileNode && fileName.length > 0) {
      fileNode.textContent = fileName;
    }
    if (barNode) {
      barNode.style.width = progress + '%';
    }
    if (percentNode) {
      percentNode.textContent = progress + '%';
    }

    fieldRow.classList.toggle('bulk-track-upload--uploading', uploading);
    status.classList.toggle('hide-element', !uploading);
  },

  ensureBulkUploadRowUploadedPreviewElement: function (fileInputElement) {
    var fileColumn = fileInputElement && fileInputElement.closest('.col3');
    if (!fileColumn) return null;

    var existing = fileColumn.querySelector('[data-action~=bulkUploadRowUploadedPreview]');
    if (existing) return existing;

    var preview = document.createElement('div');
    preview.className = 'bulk-track-upload__uploaded-preview hide-element';
    preview.setAttribute('data-action', 'bulkUploadRowUploadedPreview');
    preview.innerHTML = '' +
      '<div class="bulk-track-upload__uploaded-file" data-action="bulkUploadRowUploadedFile"></div>' +
      '<audio class="bulk-track-upload__uploaded-audio" controls preload="none" data-action="bulkUploadRowUploadedAudio"></audio>';

    fileColumn.appendChild(preview);
    return preview;
  },

  setBulkUploadRowUploadedPreviewState: function (fileInputElement, options) {
    var preview = this.ensureBulkUploadRowUploadedPreviewElement(fileInputElement);
    if (!preview) return;

    var visible = !!(options && options.visible);
    var fileName = options && options.fileName ? options.fileName : '';
    var url = options && options.url ? options.url : '';

    var fileNode = preview.querySelector('[data-action~=bulkUploadRowUploadedFile]');
    var audioNode = preview.querySelector('[data-action~=bulkUploadRowUploadedAudio]');

    if (fileNode && fileName.length > 0) {
      fileNode.textContent = fileName;
    }

    if (audioNode && url.length > 0) {
      audioNode.src = url;
    }

    preview.classList.toggle('hide-element', !visible);
  },

  resolveBulkUploadDisplayTitle: function (fileInputElement, file) {
    var fieldRow = fileInputElement && fileInputElement.closest('.fields');
    if (!fieldRow) {
      return file && file.name ? file.name : '';
    }

    var titleInput = fieldRow.querySelector('input[name$="[title]"]');
    var titleValue = titleInput && titleInput.value ? titleInput.value.trim() : '';
    if (titleValue.length > 0) {
      return titleValue;
    }

    var fileName = file && file.name ? file.name : '';
    var inferred = BulkTrackAudioAnalysis.inferTitleFromFileName(fileName);
    return inferred && inferred.length > 0 ? inferred : fileName;
  },

  showTrackDirectUploadPreview: function (formElement, url, fileName) {
    if (!formElement || !url) return;

    var preview = formElement.querySelector('[data-action~=trackDirectUploadPreview]');
    if (!preview) return;

    var source = preview.querySelector('[data-action~=trackDirectUploadPreviewSource]');
    var audio = preview.querySelector('[data-action~=trackDirectUploadPreviewAudio]');
    var title = preview.querySelector('[data-action~=trackDirectUploadPreviewTitle]');

    if (title) {
      title.textContent = fileName || '';
    }

    if (source) {
      source.src = url;
    }

    if (audio && typeof audio.load === 'function') {
      audio.load();
    }

    preview.classList.remove('hide-element');
    preview.classList.add('track-direct-upload-preview--visible');
    document.body.classList.add('track-direct-upload-preview-open');
  },

  setTrackAutofillFieldLoading: function (formElement, isLoading) {
    if (!formElement) return;
    formElement.querySelectorAll('[data-action~=trackUploadAutofillFieldHint]').forEach(function (hintNode) {
      hintNode.classList.toggle('hide-element', !isLoading);
    });
  },

  setTrackAutofillHintState: function (formElement, state) {
    if (!formElement) return;
    var hint = formElement.querySelector('[data-action~=trackUploadAutofillHint]');
    if (!hint) return;

    var messageNode = hint.querySelector('[data-action~=trackUploadAutofillHintMessage]');
    var uploadingMessage = I18n.locale === 'de' ?
      'Upload läuft: Titel, Tempo und Länge werden automatisch vorausgefüllt. Bitte warten und danach nur bei Bedarf korrigieren.' :
      'Upload in progress: title, tempo, and length are auto-filled. Please wait and only correct if needed afterward.';
    var readyMessage = I18n.locale === 'de' ?
      'Auto-Befüllung abgeschlossen: Bitte prüfen und nur bei Bedarf korrigieren.' :
      'Auto-fill completed: please review and only correct if needed.';

    if (state === 'uploading') {
      hint.classList.remove('hide-element');
      if (messageNode) messageNode.textContent = uploadingMessage;
      return;
    }

    if (state === 'ready') {
      hint.classList.remove('hide-element');
      if (messageNode) messageNode.textContent = readyMessage;
      return;
    }

    hint.classList.add('hide-element');
  },

  incrementDirectUploadPending: function (formElement) {
    if (!formElement) return;
    var current = parseInt(formElement.dataset.directUploadPending || '0', 10);
    var next = (isNaN(current) ? 0 : current) + 1;
    formElement.dataset.directUploadPending = String(next);
    this.updateDirectUploadSubmitState(formElement);
  },

  decrementDirectUploadPending: function (formElement) {
    if (!formElement) return;
    var current = parseInt(formElement.dataset.directUploadPending || '0', 10);
    var safeCurrent = isNaN(current) ? 0 : current;
    var next = Math.max(0, safeCurrent - 1);
    formElement.dataset.directUploadPending = String(next);
    this.updateDirectUploadSubmitState(formElement);
  },

  updateDirectUploadSubmitState: function (formElement) {
    if (!formElement) return;
    var pending = parseInt(formElement.dataset.directUploadPending || '0', 10);
    var disable = !isNaN(pending) && pending > 0;
    formElement.querySelectorAll('input[type="submit"], button[type="submit"]').forEach(function (submitNode) {
      submitNode.disabled = disable;
    });
  },

  initTrackDirectUploadLeaveGuard: function () {
    let forms = document.querySelectorAll('form.directUpload');
    if (!forms.length) return;

    forms.forEach(function (formElement) {
      let hasTrackMainUpload = !!formElement.querySelector('input[type="file"][name="track[s3_file_upload_url]"]');
      if (!hasTrackMainUpload) return;

      if (formElement.dataset.trackDirectUploadGuardBound === '1') return;
      formElement.dataset.trackDirectUploadGuardBound = '1';

      formElement.addEventListener('submit', function () {
        formElement.dataset.trackDirectUploadSubmitting = '1';
        formElement.dataset.trackDirectUploadUnsaved = '0';
      });
    });

    if (this.trackDirectUploadBeforeUnloadBound) return;
    this.trackDirectUploadBeforeUnloadBound = true;

    window.addEventListener('beforeunload', function (event) {
      let riskyForm = Array.from(document.querySelectorAll('form.directUpload')).find(function (formElement) {
        if (formElement.dataset.trackDirectUploadGuardBound !== '1') return false;
        if (formElement.dataset.trackDirectUploadSubmitting === '1') return false;

        let pending = parseInt(formElement.dataset.directUploadPending || '0', 10);
        let hasPendingUpload = !Number.isNaN(pending) && pending > 0;
        let hasUnsavedUpload = formElement.dataset.trackDirectUploadUnsaved === '1';

        return hasPendingUpload || hasUnsavedUpload;
      });

      if (!riskyForm) return;

      let message = (I18n.locale || '').toString().toLowerCase().startsWith('de')
        ? 'Sie haben einen hochgeladenen Track, der noch nicht gespeichert wurde. Beim Verlassen geht dieser Upload verloren.'
        : 'You have an uploaded track that is not saved yet. Leaving this page will lose this upload.';

      event.preventDefault();
      event.returnValue = message;
      return message;
    });
  },

  markTrackDirectUploadUnsaved: function (formElement, unsaved) {
    if (!formElement) return;
    formElement.dataset.trackDirectUploadUnsaved = unsaved ? '1' : '0';
    if (unsaved) {
      formElement.dataset.trackDirectUploadSubmitting = '0';
    }
  },

  addEventHandlerForRegistrationEmailCheck: function() {
    let registrationForm = document.querySelector('.registration-form');

    if (registrationForm) {
      registrationForm.addEventListener('submit', function(event) {
        let email = registrationForm.querySelector('input[type~=email]');
        let emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      
        if (!emailRegex.test(email.value)) {
          event.preventDefault();
          email.classList.add('error');
        } else {
          email.classList.remove('error');
          // you don't need to do anything here, the form will be submitted
        }
      });
    }
  },

  initMultiStepForm: function () {
    let formElement = document.querySelector('[data-action~=initMultiStepForm]');

    if (formElement) {
      formElement.addEventListener('change', function(e) {
        if (e.target.type !== 'checkbox') {
          this.submit();
        }
      })
      // formElement.addEventListener('click', function(e) {

      //   if (e.target.classList.contains('multistep-form__tab-checkbox-label')) {
      //     // do nothing
      //   } else if (e.target.type === 'checkbox') {
      //     // do nothing
      //   } else {
      //     this.submit();
      //   }
      //   // if (e.target.type !== 'checkbox' || !e.target.classList.contains('multistep-form__tab-checkbox-label')) {
      //   //   this.submit();
      //   // }

      //   // if (e.target.type !== 'checkbox' || !e.target.classList.contains('multistep-form__tab-checkbox-label')) {
      //   //   this.submit();
      //   // }
      // })
    }
  },

  initHumanVoiceoverWizard: function () {
    let formElement = document.querySelector('[data-action~=humanVoiceoverWizard]');
    if (!formElement) return;

    let draftRestored = false;
    let draftRestoreFailed = false;
    try { draftRestored = restoreVoiceoverDraft(formElement); } catch (_) { draftRestoreFailed = true; }
    if (formElement.dataset.voiceoverAuthenticated === 'true' && formElement.dataset.voiceoverRestoreDraft !== 'false') {
      let returnUrl = new URL(window.location.href);
      if (returnUrl.searchParams.has('draft')) {
        let missingNotice = formElement.querySelector('[data-voiceover-draft-missing]');
        if (missingNotice) missingNotice.hidden = draftRestored;
        if (!draftRestoreFailed) {
          returnUrl.searchParams.delete('draft');
          window.history.replaceState(window.history.state, '', returnUrl.pathname + returnUrl.search + returnUrl.hash);
        }
      }
    }

    let stepNodes = Array.from(formElement.querySelectorAll('[data-voiceover-step]'));
    let stepGroups = {};
    stepNodes.forEach(function (node) {
      let step = node.getAttribute('data-voiceover-step');
      stepGroups[step] = stepGroups[step] || [];
      stepGroups[step].push(node);
    });

    let stepNumbers = Object.keys(stepGroups).sort(function (left, right) { return parseInt(left, 10) - parseInt(right, 10); });
    let stepItems = Array.from(formElement.querySelectorAll('[data-voiceover-step-item]'));
    let stepLinks = Array.from(formElement.querySelectorAll('[data-voiceover-step-link]'));
    let stepLabel = formElement.querySelector('[data-voiceover-step-label]');
    let stepProgress = formElement.querySelector('[data-voiceover-step-progress]');
    let initialStep = parseInt(formElement.getAttribute('data-voiceover-initial-step') || '1', 10);
    let maxSegments = parseInt(formElement.getAttribute('data-voiceover-max-segments') || '20', 10);
    let currentIndex = Math.max(0, Math.min(initialStep - 1, stepNumbers.length - 1));
    if (draftRestored) {
      let billingIndex = stepNumbers.indexOf('5');
      currentIndex = formElement.querySelector('input[name="human_voiceover_request[requested_speaker_id]"]:checked') ? (billingIndex >= 0 ? billingIndex : 1) : 0;
    }
    let authLinks = Array.from(formElement.querySelectorAll('[data-voiceover-auth-link]'));
    let usageQuestionNodes = Array.from(formElement.querySelectorAll('[data-voiceover-usage-question]'));
    let usageCategoryField = formElement.querySelector('[name="human_voiceover_request[usage_answers][project_category]"]');
    let billingFieldNodes = Array.from(formElement.querySelectorAll('[data-voiceover-billing-field]'));
    let billingConfirmation = formElement.querySelector('[data-voiceover-billing-confirmation]');

    function updateAuthLinks() {
      let speaker = formElement.querySelector('input[name="human_voiceover_request[requested_speaker_id]"]:checked');
      authLinks.forEach(function (link) {
        let authUrl = new URL(link.href);
        let returnUrl = new URL(authUrl.searchParams.get('return_to'), window.location.origin);
        if (speaker && speaker.value) {
          returnUrl.searchParams.set('requested_speaker_id', speaker.value);
        } else {
          returnUrl.searchParams.delete('requested_speaker_id');
        }
        authUrl.searchParams.set('return_to', returnUrl.pathname + returnUrl.search + returnUrl.hash);
        link.href = authUrl.toString();
      });
      let speakerError = formElement.querySelector('[data-voiceover-speaker-error]');
      if (speakerError && !speakerError.hidden) validateStep(0, false);
    }
    formElement.addEventListener('change', updateAuthLinks);
    updateAuthLinks();
    let stepNames = stepItems.map(function (item) {
      let name = item.querySelector('.header-stepper__name');
      return name ? name.textContent.trim() : '';
    });

    function setFieldValidity(field, valid) {
      field.classList.toggle('input--invalid', !valid);
      let error = Array.from(formElement.querySelectorAll('[data-voiceover-field-error-for]')).find(function (candidate) {
        return candidate.getAttribute('data-voiceover-field-error-for') === field.id;
      });
      if (valid) {
        field.removeAttribute('aria-invalid');
        if (error) error.remove();
        let describedBy = String(field.getAttribute('aria-describedby') || '').split(/\s+/).filter(function (id) {
          return id && (!error || id !== error.id);
        });
        if (describedBy.length > 0) field.setAttribute('aria-describedby', describedBy.join(' '));
        else field.removeAttribute('aria-describedby');
      } else {
        field.setAttribute('aria-invalid', 'true');
        if (field.type === 'radio') return;

        if (!field.id) field.id = 'human-voiceover-required-field-' + Array.from(formElement.querySelectorAll('[required]')).indexOf(field);
        if (!error) {
          error = document.createElement('p');
          error.id = field.id + '-error';
          error.className = 'human-voiceover-field-error text-size-small';
          error.setAttribute('role', 'alert');
          error.setAttribute('data-voiceover-field-error-for', field.id);
          let label = Array.from(formElement.querySelectorAll('label')).find(function (candidate) { return candidate.htmlFor === field.id; }) || field.closest('label');
          let labelText = field.dataset.voiceoverValidationLabel || (label ? label.textContent.trim() : '');
          let language = window.I18n && window.I18n.locale || document.documentElement.lang || (document.body && document.body.dataset.lang);
          let isGerman = String(language || '').toLowerCase().startsWith('de');
          error.textContent = labelText
            ? (isGerman ? labelText + ' ist ein Pflichtfeld.' : labelText + ' is required.')
            : (isGerman ? 'Bitte füllen Sie dieses Pflichtfeld aus.' : 'Please complete this required field.');
          let insertionPoint = field.closest('label') || field;
          insertionPoint.insertAdjacentElement('afterend', error);
        }
        let describedBy = String(field.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean);
        if (!describedBy.includes(error.id)) describedBy.push(error.id);
        field.setAttribute('aria-describedby', describedBy.join(' '));
      }
    }

    function clearValidFieldError(event) {
      let field = event.target;
      if (!field || !field.matches || !field.matches('[required]:not(:disabled)') || !field.hasAttribute('aria-invalid')) return;

      let valid = field.type === 'checkbox'
        ? field.checked
        : field.type === 'radio'
          ? Array.from(formElement.querySelectorAll('input[type="radio"]')).some(function (candidate) { return candidate.name === field.name && candidate.checked; })
          : String(field.value || '').trim().length > 0;
      if (valid) setFieldValidity(field, true);
    }

    formElement.addEventListener('input', clearValidFieldError);
    formElement.addEventListener('change', clearValidFieldError);

    function usageAnswersComplete() {
      if (!usageQuestionNodes.length) return false;

      let applicableQuestions = usageQuestionNodes.filter(function (node) { return !node.hidden; });
      let requiredFields = applicableQuestions.reduce(function (fields, node) {
        return fields.concat(Array.from(node.querySelectorAll('select[required]')));
      }, []);
      if (requiredFields.some(function (field) { return String(field.value || '').trim().length === 0; })) return false;

      let channelGroup = applicableQuestions.map(function (node) { return node.querySelector('[data-voiceover-usage-checkbox-group][data-voiceover-usage-required="true"]'); }).find(Boolean);
      return !channelGroup || !!channelGroup.querySelector('input[type="checkbox"]:checked');
    }

    function refreshBillingRequirement() {
      let required = usageAnswersComplete();
      billingFieldNodes.forEach(function (field) {
        let isOptionalVatId = field.id === 'human-voiceover-billing-vat-id';
        if (isOptionalVatId) return;
        if (required) {
          field.setAttribute('required', 'required');
          field.setAttribute('aria-required', 'true');
        } else {
          field.removeAttribute('required');
          field.removeAttribute('aria-required');
        }
      });
      if (billingConfirmation) {
        if (required) {
          billingConfirmation.setAttribute('required', 'required');
          billingConfirmation.setAttribute('aria-required', 'true');
        } else {
          billingConfirmation.removeAttribute('required');
          billingConfirmation.removeAttribute('aria-required');
        }
      }
    }

    function refreshUsageQuestions(clearInapplicable) {
      if (!usageQuestionNodes.length) return;
      let category = usageCategoryField ? usageCategoryField.value : '';

      usageQuestionNodes.forEach(function (node) {
        let categories = String(node.getAttribute('data-voiceover-usage-categories') || '').split(/\s+/).filter(Boolean);
        let applicable = categories.length === 0 || (category && categories.indexOf(category) >= 0);
        if (!applicable && clearInapplicable) {
          node.querySelectorAll('input, select').forEach(function (field) {
            if (field.type === 'checkbox') field.checked = false;
            else field.value = '';
          });
        }
        node.hidden = !applicable;
        let stepContainer = node.closest('[data-voiceover-step]');
        if (!stepContainer || !stepContainer.hidden) {
          node.querySelectorAll('input, select').forEach(function (field) { field.disabled = !applicable; });
        }
        node.querySelectorAll('option[data-voiceover-usage-categories]').forEach(function (option) {
          let optionCategories = String(option.getAttribute('data-voiceover-usage-categories') || '').split(/\s+/).filter(Boolean);
          let optionApplicable = optionCategories.length === 0 || (category && optionCategories.indexOf(category) >= 0);
          option.hidden = !optionApplicable;
          option.disabled = !optionApplicable;
          if (!optionApplicable && option.parentElement.value === option.value) option.parentElement.value = '';
        });
      });
      refreshBillingRequirement();
    }

    function validateStep(index, focusInvalid) {
      let step = stepGroups[stepNumbers[index]] || [];
      let requiredFields = [];
      step.forEach(function (node) {
        requiredFields = requiredFields.concat(Array.from(node.querySelectorAll('[required]:not(:disabled)')));
      });

      let firstInvalidField = null;
      requiredFields.forEach(function (field) {
        let valid = field.type === 'checkbox' || field.type === 'radio'
          ? field.checked
          : String(field.value || '').trim().length > 0;
        if (field.type === 'radio') {
          valid = requiredFields.some(function (candidate) { return candidate.type === 'radio' && candidate.name === field.name && candidate.checked; });
        }
        setFieldValidity(field, valid);
        if (!valid && !firstInvalidField) firstInvalidField = field;
      });

      let speakerError = formElement.querySelector('[data-voiceover-speaker-error]');
      if (speakerError && stepNumbers[index] === '1') speakerError.hidden = !firstInvalidField;

      step.forEach(function (node) {
        node.querySelectorAll('[data-voiceover-usage-checkbox-group][data-voiceover-usage-required="true"]').forEach(function (group) {
          let valid = !!group.querySelector('input[type="checkbox"]:checked');
          let error = group.querySelector('.human-voiceover-usage-error');
          group.setAttribute('aria-invalid', valid ? 'false' : 'true');
          if (error) error.hidden = valid;
          if (!valid && !firstInvalidField) firstInvalidField = group.querySelector('input[type="checkbox"]');
        });
      });
      if (firstInvalidField && focusInvalid !== false) firstInvalidField.focus();
      return !firstInvalidField;
    }

    function updateSegmentControls() {
      let segmentContainer = formElement.querySelector('[data-voiceover-segments]');
      let addButton = formElement.querySelector('[data-voiceover-add-segment]');
      if (!segmentContainer || !addButton) return;

      let count = segmentContainer.querySelectorAll('[data-voiceover-segment]').length;
      let atLimit = count >= maxSegments;
      addButton.disabled = atLimit;
      addButton.setAttribute('aria-disabled', atLimit ? 'true' : 'false');
    }

    function setStepControlsDisabled(step, disabled) {
      step.querySelectorAll('input, textarea, select, button').forEach(function (control) {
        control.disabled = disabled || control.getAttribute('data-voiceover-unavailable') === 'true';
      });
    }

    function announceSegmentChange(action) {
      let statusNode = formElement.querySelector('[data-voiceover-segment-status]');
      let segmentContainer = formElement.querySelector('[data-voiceover-segments]');
      if (!statusNode || !segmentContainer) return;

      let labelAttribute = action === 'added' ? 'data-voiceover-segment-added-label' : 'data-voiceover-segment-removed-label';
      let label = statusNode.getAttribute(labelAttribute) || (action === 'added' ? 'Script segment added' : 'Script segment removed');
      let count = segmentContainer.querySelectorAll('[data-voiceover-segment]').length;
      statusNode.textContent = label + ' (' + count + ').';
      statusNode.hidden = false;
    }

    function renumberSegments() {
      let segmentContainer = formElement.querySelector('[data-voiceover-segments]');
      if (!segmentContainer) return;

      let segmentLabel = segmentContainer.getAttribute('data-voiceover-segment-label') || 'Script segment %{number}';
      Array.from(segmentContainer.querySelectorAll('[data-voiceover-segment]')).forEach(function (segment, index) {
        segment.querySelectorAll('[id]').forEach(function (field) {
          field.id = field.id.replace(/-\d+-/, '-' + index + '-');
        });
        segment.querySelectorAll('[for]').forEach(function (label) {
          label.setAttribute('for', label.getAttribute('for').replace(/-\d+-/, '-' + index + '-'));
        });
        segment.querySelectorAll('[name]').forEach(function (field) {
          field.name = field.name.replace(/segments\]\[\d+\]/, 'segments][' + index + ']');
        });
        let heading = segment.querySelector('h3');
        if (heading) heading.textContent = segmentLabel.replace('%{number}', String(index + 1));
      });
    }

    function updateStepUi() {
      stepNumbers.forEach(function (step, index) {
        (stepGroups[step] || []).forEach(function (node) {
          let isCurrent = index === currentIndex;
          node.hidden = !isCurrent;
          setStepControlsDisabled(node, !isCurrent);
        });
      });

      stepItems.forEach(function (item) {
        let step = parseInt(item.getAttribute('data-voiceover-step-item'), 10);
        item.classList.toggle('is-current', step === currentIndex + 1);
        item.classList.toggle('is-done', step < currentIndex + 1);
        item.classList.toggle('is-upcoming', step > currentIndex + 1);
      });

      stepLinks.forEach(function (link) {
        let step = parseInt(link.getAttribute('data-voiceover-step-link'), 10);
        if (step === currentIndex + 1) {
          link.setAttribute('aria-current', 'step');
        } else {
          link.removeAttribute('aria-current');
        }
        if (step > currentIndex + 1) {
          link.setAttribute('aria-disabled', 'true');
          link.setAttribute('tabindex', '-1');
        } else {
          link.removeAttribute('aria-disabled');
          link.removeAttribute('tabindex');
        }
      });

      if (stepLabel) {
        let localePrefix = (I18n.locale || '').toString().toLowerCase().startsWith('de') ? 'Schritt' : 'Step';
        let ofLabel = (I18n.locale || '').toString().toLowerCase().startsWith('de') ? 'von' : 'of';
        stepLabel.textContent = localePrefix + ' ' + (currentIndex + 1) + ' ' + ofLabel + ' ' + stepItems.length + ' — ' + stepNames[currentIndex];
      }
      if (stepProgress) stepProgress.style.width = (((currentIndex + 1) / stepItems.length) * 100).toFixed(0) + '%';
    }

    function moveTo(index) {
      currentIndex = Math.max(0, Math.min(index, stepNumbers.length - 1));
      updateStepUi();
      refreshUsageQuestions(false);
      let activeStep = stepGroups[stepNumbers[currentIndex]] && stepGroups[stepNumbers[currentIndex]][0];
      let heading = activeStep && activeStep.querySelector('h1, h2');
      if (heading) {
        heading.setAttribute('tabindex', '-1');
        heading.focus({ preventScroll: true });
      }
      if (formElement.scrollIntoView) formElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    document.querySelectorAll('[data-voiceover-start-step]').forEach(function (link) {
      link.addEventListener('click', function (event) {
        event.preventDefault();
        let targetStep = parseInt(link.getAttribute('data-voiceover-start-step'), 10);
        if (targetStep > 0) moveTo(targetStep - 1);
        formElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    formElement.addEventListener('click', function (event) {
      let nextButton = event.target.closest('[data-voiceover-next]');
      let previousButton = event.target.closest('[data-voiceover-prev]');
      let stepLink = event.target.closest('[data-voiceover-step-link]');
      let addSegmentButton = event.target.closest('[data-voiceover-add-segment]');
      let removeSegmentButton = event.target.closest('[data-voiceover-remove-segment]');

      if (nextButton) {
        event.preventDefault();
        refreshUsageQuestions(false);
        if (validateStep(currentIndex)) moveTo(currentIndex + 1);
      } else if (previousButton) {
        event.preventDefault();
        moveTo(currentIndex - 1);
      } else if (stepLink) {
        event.preventDefault();
        let targetIndex = parseInt(stepLink.getAttribute('data-voiceover-step-link'), 10) - 1;
        if (targetIndex <= currentIndex) moveTo(targetIndex);
      } else if (addSegmentButton) {
        event.preventDefault();
        let segmentContainer = formElement.querySelector('[data-voiceover-segments]');
        let template = formElement.querySelector('[data-voiceover-segment-template]');
        if (!segmentContainer || !template || segmentContainer.querySelectorAll('[data-voiceover-segment]').length >= maxSegments) return;

        let nextIndex = segmentContainer.querySelectorAll('[data-voiceover-segment]').length;
        let nextNumber = nextIndex + 1;
        let html = template.innerHTML.replace(/__INDEX__/g, String(nextIndex)).replace(/__NUMBER__/g, String(nextNumber));
        segmentContainer.insertAdjacentHTML('beforeend', html);
        updateSegmentControls();
        let addedSegment = segmentContainer.querySelectorAll('[data-voiceover-segment]')[nextIndex];
        let addedText = addedSegment && addedSegment.querySelector('textarea');
        if (addedText) addedText.focus();
        announceSegmentChange('added');
      } else if (removeSegmentButton) {
        event.preventDefault();
        let segmentContainer = formElement.querySelector('[data-voiceover-segments]');
        let segment = removeSegmentButton.closest('[data-voiceover-segment]');
        if (!segment || !segmentContainer || segmentContainer.querySelectorAll('[data-voiceover-segment]').length <= 1) return;

        let nextFocusSegment = segment.nextElementSibling || segment.previousElementSibling;
        segment.remove();
        renumberSegments();
        updateSegmentControls();
        let nextFocusText = nextFocusSegment && nextFocusSegment.querySelector('textarea');
        if (nextFocusText) nextFocusText.focus();
        announceSegmentChange('removed');
      }
    });

    function firstInvalidStep() {
      stepNodes.forEach(function (node) { setStepControlsDisabled(node, false); });
      refreshUsageQuestions(false);
      let invalidStep = stepNumbers.findIndex(function (_step, index) { return !validateStep(index, false); });
      updateStepUi();
      refreshUsageQuestions(false);
      return invalidStep;
    }

    authLinks.forEach(function (link) {
      link.addEventListener('click', function (event) {
        let invalidStep = firstInvalidStep();
        if (invalidStep >= 0) {
          event.preventDefault();
          moveTo(invalidStep);
          validateStep(invalidStep);
          return;
        }
        try {
          let authUrl = new URL(link.href);
          authUrl.searchParams.set('return_to', saveVoiceoverDraft(formElement, authUrl.searchParams.get('return_to')));
          link.href = authUrl.toString();
        } catch (_) {
          event.preventDefault();
          let error = formElement.querySelector('[data-voiceover-draft-error]');
          if (error) error.hidden = false;
          let fallback = formElement.querySelector('[data-voiceover-draft-fallback]');
          if (fallback) fallback.hidden = false;
        }
      });
    });

    formElement.addEventListener('submit', function (event) {
      if (formElement.dataset.voiceoverAuthenticated === 'false') {
        event.preventDefault();
        if (authLinks[0]) authLinks[0].click();
        return;
      }
      let invalidStep = firstInvalidStep();
      if (invalidStep >= 0) {
        event.preventDefault();
        moveTo(invalidStep);
        validateStep(invalidStep);
      } else {
        stepNodes.forEach(function (node) { setStepControlsDisabled(node, false); });
        refreshUsageQuestions(false);
      }
    });

    renumberSegments();
    updateSegmentControls();
    updateStepUi();
    if (usageCategoryField) usageCategoryField.addEventListener('change', function () { refreshUsageQuestions(true); });
    formElement.addEventListener('change', function (event) {
      if (event.target.closest('[data-voiceover-usage-question]')) refreshBillingRequirement();
    });
    refreshUsageQuestions(false);
    if (draftRestored) {
      formElement.dispatchEvent(new Event('change', { bubbles: true }));
      let restoredNotice = formElement.querySelector('[data-voiceover-draft-restored]');
      if (restoredNotice) restoredNotice.hidden = false;
    }

    if (window.location.hash === '#' + formElement.id && !formElement.hidden) {
      let focusInitialStepHeading = function () {
        let initialStep = stepGroups[stepNumbers[currentIndex]] || [];
        let heading = initialStep[0] && initialStep[0].querySelector('h1, h2');
        if (!heading || formElement.hidden || !formElement.isConnected) return;

        heading.setAttribute('tabindex', '-1');
        heading.focus({ preventScroll: true });
      };

      if (document.readyState === 'complete') {
        window.requestAnimationFrame(focusInitialStepHeading);
      } else {
        window.addEventListener('load', function () {
          window.requestAnimationFrame(focusInitialStepHeading);
        }, { once: true });
      }
    }
  },

  initElementCatapult: function () {
    legacyEventHub.on('elementCatapult', function () {
      let type = arguments[0][0],
        sourceNode = arguments[0][1],
        targetNode,
        sourceNodePositionX,
        sourceNodePositionY,
        targetNodePositionX,
        targetNodePositionY,
        cloneElement;

      if (type && sourceNode) {
        if (type === 'cart') {

          targetNode = document.querySelector('.nav .cart');
          if (targetNode) {
            let sourceRect = sourceNode.getBoundingClientRect();
            let targetRect = targetNode.getBoundingClientRect();
            sourceNodePositionX = sourceRect.left;
            sourceNodePositionY = sourceRect.top;
            targetNodePositionX = targetRect.left;
            targetNodePositionY = targetRect.top;

            sourceNode.style.opacity = '0';
            cloneElement = sourceNode.cloneNode(true);
            cloneElement.style.opacity = '1';
            cloneElement.style.left = String(sourceNodePositionX) + 'px';
            cloneElement.style.top = String(sourceNodePositionY) + 'px';
            cloneElement.classList.add('catapult-item', 'catapult-item--cart');
            document.body.appendChild(cloneElement);

            setTimeout(function () {
              document.querySelectorAll('.catapult-item').forEach(function (node) {
                node.style.left = String(targetNodePositionX + 20) + 'px';
                node.style.top = String(targetNodePositionY - 5) + 'px';
                node.style.opacity = '0';
              });
            }, 200);

            setTimeout(function () {
              document.querySelectorAll('.catapult-item').forEach(function (node) {
                node.style.marginTop = '40px';
              });
            }, 1000);

            setTimeout(function () {
              document.querySelectorAll('.catapult-item').forEach(function (node) {
                node.remove();
              });
              sourceNode.style.opacity = '1';
            }, 1200);
          }
        }
      }
    });
  }
}

export default globalModule;
